// import React, { useCallback, useEffect, useRef, useState } from "react";
// import { AddIcon, GetIcon } from "../../../../../icons";
// import { AddButton, ButtonPanel, Count, Filter, FilterBox, Filters, NoData, ScrollContainerLayout, ScrollLayout, Table, Td, Th, ToggleInput, ToggleSwitch, ToggleSwitchContainer, Tr } from "../../../../elements/list/styles";
// import Search from "../../../../elements/search";
// import { ColumnContainer, RowContainer } from "../../../../styles/containers/styles";
// import Layout from "../../../common/layout";
// import { useDispatch, useSelector } from "react-redux";
// import { useTranslation } from "react-i18next";
// import { addPageObject } from "../../../../../store/actions/pages";
// import moment from "moment";
// import { Absence, Collapse, HoverActions, Schedule, SchedulesBox } from "./styles";
// import { timeFormat } from "../../../../functions/date";
// import { BlankButton } from "../styels";
// import { getData, postData, putData } from "../../../../../backend/api";
// import AutoForm from "../../../../elements/form";
// import { generateThumbnail } from "../../../../functions/string";
// import { Container } from "../../../common/layout/styels";
// import "../schedules/DragSelectDelete.css"; // Import your own CSS file for styling
// import { CenterBox, DayBox } from "../worklog/styles";
// import SelectTab from "../../../../elements/selectTab";
// import DateSelector from "../../../../elements/dateselector";
// import { convertMinutesToHHMM } from "../../../../functions/dataFormat";
// import Progress from "../../../../elements/progress";
// import { Title } from "../../../common/layout/header/styels";
// import FormInput from "../../../../elements/input";
// import { AvailabilitiesSchedule } from "../../employee/schedule/style";
// // import CrudForm from "../../../../elements/list/create";
// // import { useNavigate } from "react-router-dom";
// const Duty = ({ setLoaderBox, setMessage, shortName = "layer" }) => {
//   const [currentApi] = useState(`shift/schedules`);
//   const [currentIndex] = useState(0);
//   const themeColors = useSelector((state) => state.themeColors);
//   const [t] = useTranslation();
//   const [searchValue, setSearchValue] = useState("");
//   const searchTimeoutRef = useRef();
//   const [count, setCount] = useState(0);
//   const [initialized] = useState(true);
//   const dispatch = useDispatch();
//   const [openData, setOpenData] = useState([]);
//   const [openedPlace, setOpenedPlace] = useState(() => {
//     const storedProjects = localStorage.getItem("project");
//     return storedProjects ? JSON.parse(storedProjects) : {};
//   });

//   // const [dragOverId, setDragOverId] = useState("");
//   const [overid, setOverId] = useState("");
//   const [title, setTitle] = useState("");
//   const [selectedSchedule, setSelectedSchedule] = useState({});
//   const { i18n } = useTranslation();
//   const [viewMode, setViewMode] = useState("month");
//   const [showWorked, setShowWorked] = useState(false);
//   const [selectedLanguage] = useState(i18n.language || "de");
//   // const navigate = useNavigate();
//   const handleChange = (event) => {
//     clearTimeout(searchTimeoutRef.current);
//     setSearchValue(event.target.value);
//     searchTimeoutRef.current = setTimeout(() => {
//       setFilterView({ ...filterView, searchkey: event.target.value });
//     }, 300);
//   };
//   const [workTimeLog, setWorkTimeLog] = useState([]);
//   const [dayTimeLog] = useState([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23]);
//   const [filterView, setFilterView] = useState({
//     place: "",
//     shift: "",
//     viewMode: "month",
//     show: "1",
//     currentDate: new Date().toISOString(),
//     startOfMonth: moment(new Date()).startOf("month").toISOString(),
//     endOfMonth: moment(new Date()).endOf("month").toISOString(),
//     startOfWeek: moment(new Date()).startOf("week").toISOString(),
//     endOfWeek: moment(new Date()).endOf("week").toISOString(),
//   });

//   // const [attributes] = useState([
//   //   {
//   //     type: "select",
//   //     placeholder: "place",
//   //     name: "place",
//   //     showItem: "title",
//   //     validation: "",
//   //     default: "",
//   //     label: "place",
//   //     required: true,
//   //     view: true,
//   //     add: true,
//   //     update: true,
//   //     apiType: "API",
//   //     selectApi: "place/select",
//   //   },
//   // ]);
//   useEffect(() => {
//     localStorage.setItem("project", JSON.stringify(openedPlace));
//   }, [openedPlace]);
//   const dateRangeChange = (item) => {
//     const udpateValue = {
//       ...filterView,
//       ...item,
//       viewMode,
//     };
//     setFilterView(udpateValue);
//   };
//   const filterChange = (index,option, name) => {
//     const udpateValue = {
//       ...filterView,
//       [name]: option.id,
//     };
//     // updating the formm values
//     setFilterView(udpateValue);
//   };
//   const changeWorkLog = useCallback(
//     (item) => {
//       let startDateTemp, endDateTemp;
//       const workLog = [];

//       // Using a switch to determine start and end dates based on viewMode
//       switch (item.viewMode) {
//         case "month":
//           startDateTemp = moment(item.startOfMonth).toDate();
//           endDateTemp = moment(item.endOfMonth).toDate();
//           break;
//         case "week":
//           startDateTemp = moment(item.startOfWeek).toDate();
//           endDateTemp = moment(item.endOfWeek).toDate();
//           break;
//         case "day":
//           startDateTemp = moment(item.currentDate).toDate();
//           endDateTemp = moment(item.currentDate).toDate();
//           break;
//         default:
//           startDateTemp = moment(item.startOfMonth).toDate();
//           endDateTemp = moment(item.endOfMonth).toDate();
//           break;
//       }

//       // Loop through dates and populate the workLog array
//       for (let date = moment(startDateTemp); date.isSameOrBefore(endDateTemp); date.add(1, "day")) {
//         workLog.push({
//           originalDate: date.toDate(),
//           date: date.format("YYYY-MM-DD"),
//           day: date.format("DD"),
//           dayNameId: date.locale("en").format("ddd"),
//           dayName: date.locale(selectedLanguage).format("ddd"),
//         });
//       }

//       // Assuming setWorkTimeLog is a function to update the state with the workLog
//       setWorkTimeLog([...workLog]); // Using spread to create a new array and trigger state update
//     },
//     [setWorkTimeLog, selectedLanguage]
//   ); // Adding dependencies for useCallback

//   useEffect(() => {
//     changeWorkLog(filterView);
//   }, [filterView, changeWorkLog]);
//   const [loadedData, setLoadedData] = useState([]);
//   //Loading Data
//   const users = useSelector((state) =>
//     state.pages[`${currentApi}`]
//       ? state.pages[`${currentApi}`]
//       : {
//           data: null,
//           isLoading: true,
//           error: null,
//         }
//   );
//   // const [draggedDates, setDraggedDates] = useState([]);
//   useEffect(() => {
//     setLoadedData(users);
//   }, [users]);
//   const [addAtrributes, setAddAttributes] = useState([]);
//   const [saveApiUrl, setSaveApiUrl] = useState("");
//   const [updateApiUrl, setUpdateApiUrl] = useState("");
//   const [addOverrideUpdate, setAddOverrideUpdate] = useState([]);
//   const [condition] = useState({ item: "reccuring", if: true, then: "enabled", else: "disabled" });
//   const [shiftCondition] = useState({ item: "shift", if: "", else: "enabled", then: "disabled" });
//   const [isAddNewSchedule, setIsAddNewSchedule] = useState(false);
//   const [modifySchedule, setModifySchedule] = useState(false);
//   const [userId, setUserId] = useState("nil");
//   const addNewSchedule = (entry, item) => {
//     let date = moment(entry.originalDate);
//     setSaveApiUrl("shift/addSchedule");
//     setTitle("layer");
//     if (item._id) {
//       setUserId(item._id);
//       setAddAttributes([
//         {
//           type: "title",
//           name: "scheduleTo",
//           validation: "",
//           title: t("scheduleFor", { name: item.fullName }),
//           label: "scheduleTo",
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "info",
//           name: "scheduleTo",
//           validation: "",
//           title: ``,
//           label: "scheduleTo",
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "select",
//           placeholder: "shift",
//           name: "shiftTemplate",
//           validation: "",
//           updateCondition: [
//             { item: "shiftStart", value: "shiftStart" },
//             { item: "shiftEnd", value: "shiftEnd" },
//             { item: "startBuffer", value: "startBuffer" },
//             { item: "endBuffer", value: "endBuffer" },
//             { item: "break", value: "break" },
//           ],
//           tags: [
//             { type: "time", item: "shiftStart", title: "shiftStart", collection: "" },
//             { type: "time", item: "shiftEnd", title: "shiftEnd", collection: "" },
//           ],
//           default: "",
//           label: "shift",
//           showItem: "title",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//           apiType: "API",
//           selectApi: "shift/select",
//           customClass: "half",
//         },

//         {
//           type: "textarea",
//           placeholder: "note",
//           name: "title",
//           validation: "",
//           condition: shiftCondition,
//           default: "",
//           label: "note",
//           required: false,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "date",
//           placeholder: "scheduleDate",
//           condition: shiftCondition,
//           name: "startDate",
//           validation: "",
//           default: moment(entry.date).startOf("day").add(7, "hours"),
//           label: "scheduleDate",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "time",
//           placeholder: "shiftStart",
//           name: "shiftStart",
//           validation: "",
//           condition: shiftCondition,
//           default: date.clone().add(7, "hours"),
//           label: "shiftStart",
//           required: true,
//           interval: 15,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "time",
//           placeholder: "shiftEnd",
//           name: "shiftEnd",
//           condition: shiftCondition,
//           validation: "",
//           default: date.clone().add(19, "hours"),
//           label: "shiftEnd",
//           required: true,
//           interval: 15,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "number",
//           placeholder: "startBuffer",
//           condition: shiftCondition,
//           name: "startBuffer",
//           validation: "",
//           default: "",
//           showItem: "value",
//           label: "startBuffer",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//           customClass: "half",
//           filter: false,
//           apiType: "JSON",
//           selectApi: [
//             { value: "10 minutes", id: 10 },
//             { value: "15 minutes", id: 15 },
//             { value: "20 minutes", id: 20 },
//             { value: "25 minutes", id: 25 },
//             { value: "30 minutes", id: 30 },
//             { value: "45 minutes", id: 45 },
//             { value: "60 minutes", id: 60 },
//           ],
//         },
//         {
//           type: "number",
//           placeholder: "endBuffer",
//           condition: shiftCondition,
//           name: "endBuffer",
//           validation: "",
//           default: "",
//           showItem: "value",
//           label: "endBuffer",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//           customClass: "half",
//           filter: false,
//           apiType: "JSON",
//           selectApi: [
//             { value: "10 minutes", id: 10 },
//             { value: "15 minutes", id: 15 },
//             { value: "20 minutes", id: 20 },
//             { value: "25 minutes", id: 25 },
//             { value: "30 minutes", id: 30 },
//             { value: "45 minutes", id: 45 },
//             { value: "60 minutes", id: 60 },
//           ],
//         },
//         {
//           type: "number",
//           placeholder: "break",
//           condition: shiftCondition,
//           name: "break",
//           validation: "",
//           default: "0",
//           label: "break",
//           required: true,
//           minimum: 0,
//           maximum: 60,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "hidden",
//           placeholder: "employee",
//           name: "user",
//           validation: "",
//           default: [[item._id]],
//           label: "employee",
//           showItem: "employee",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//           apiType: "API",
//           selectApi: "user/select",
//           customClass: "half",
//         },
//         {
//           type: "info",
//           placeholder: "days",
//           name: "days",
//           validation: "",
//           default: false,
//           label: "days",
//           required: true,
//           minimum: 0,
//           maximum: 60,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "checkbox",
//           placeholder: "reccuring",
//           condition: shiftCondition,
//           name: "reccuring",
//           validation: "",
//           default: false,
//           label: "reccuring",
//           required: true,
//           minimum: 0,
//           maximum: 60,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "info",
//           placeholder: "days",
//           name: "days",
//           content: "selectDays",
//           validation: "",
//           condition: condition,
//           default: false,
//           label: "days",
//           required: true,
//           minimum: 0,
//           maximum: 60,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "info",
//           placeholder: "days",
//           name: "days",
//           validation: "",
//           default: false,
//           label: "days",
//           required: true,
//           minimum: 0,
//           maximum: 60,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "multiSelect",
//           placeholder: "eligibleDays",
//           listView: true,
//           name: "eligibleDays",
//           validation: "",
//           default: "",
//           label: "eligibleDays",
//           required: true,
//           view: true,
//           condition: condition,
//           customClass: "half",
//           add: true,
//           update: true,
//           apiType: "JSON",
//           selectApi: [
//             { value: t("Monday"), id: "monday" },
//             { value: t("Tuesday"), id: "tuesday" },
//             { value: t("Wednesday"), id: "wednesday" },
//             { value: t("Thursday"), id: "thursday" },
//             { value: t("Friday"), id: "friday" },
//             { value: t("Saturday"), id: "saturday" },
//             { value: t("Sunday"), id: "sunday" },
//           ],
//         },
//         {
//           type: "date",
//           placeholder: "scheduleEnd",
//           name: "endDate",
//           validation: "",
//           condition: condition,
//           greater: "startDate",
//           minDate: date.clone().add(1, "days"),
//           maxDate: date.clone().add(3, "months"),
//           default: date.clone().startOf("day").add(15, "hours"),
//           label: "scheduleEnd",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//         },
//       ]);
//     } else {
//       setAddAttributes([
//         {
//           type: "select",
//           placeholder: "shift",
//           name: "shiftTemplate",
//           validation: "",
//           updateCondition: [
//             { item: "shiftStart", value: "shiftStart" },
//             { item: "shiftEnd", value: "shiftEnd" },
//             { item: "startBuffer", value: "startBuffer" },
//             { item: "endBuffer", value: "endBuffer" },
//             { item: "break", value: "break" },
//           ],
//           tags: [
//             { type: "time", item: "shiftStart", title: "shiftStart", collection: "" },
//             { type: "time", item: "shiftEnd", title: "shiftEnd", collection: "" },
//           ],
//           default: "",
//           label: "shift",
//           showItem: "title",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//           apiType: "API",
//           selectApi: "shift/select",
//           customClass: "half",
//         },

//         {
//           type: "date",
//           placeholder: "scheduleDate",
//           condition: shiftCondition,
//           name: "startDate",
//           validation: "",
//           minDate: date.clone(),
//           maxDate: date.clone().add(3, "months"),
//           default: date.clone().startOf("day").add(7, "hours"),
//           label: "scheduleDate",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "time",
//           placeholder: "shiftStart",
//           name: "shiftStart",
//           validation: "",
//           condition: shiftCondition,
//           default: date.clone().add(7, "hours"),
//           label: "shiftStart",
//           required: true,
//           interval: 15,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "time",
//           placeholder: "shiftEnd",
//           name: "shiftEnd",
//           condition: shiftCondition,
//           validation: "",
//           default: date.clone().add(19, "hours"),
//           label: "shiftEnd",
//           required: true,
//           interval: 15,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "number",
//           placeholder: "startBuffer",
//           condition: shiftCondition,
//           name: "startBuffer",
//           validation: "",
//           default: "",
//           showItem: "value",
//           label: "startBuffer",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//           customClass: "half",
//           filter: false,
//           apiType: "JSON",
//           selectApi: [
//             { value: "10 minutes", id: 10 },
//             { value: "15 minutes", id: 15 },
//             { value: "20 minutes", id: 20 },
//             { value: "25 minutes", id: 25 },
//             { value: "30 minutes", id: 30 },
//             { value: "45 minutes", id: 45 },
//             { value: "60 minutes", id: 60 },
//           ],
//         },
//         {
//           type: "number",
//           placeholder: "endBuffer",
//           condition: shiftCondition,
//           name: "endBuffer",
//           validation: "",
//           default: "",
//           showItem: "value",
//           label: "endBuffer",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//           customClass: "half",
//           filter: false,
//           apiType: "JSON",
//           selectApi: [
//             { value: "10 minutes", id: 10 },
//             { value: "15 minutes", id: 15 },
//             { value: "20 minutes", id: 20 },
//             { value: "25 minutes", id: 25 },
//             { value: "30 minutes", id: 30 },
//             { value: "45 minutes", id: 45 },
//             { value: "60 minutes", id: 60 },
//           ],
//         },
//         {
//           type: "number",
//           placeholder: "break",
//           condition: shiftCondition,
//           name: "break",
//           validation: "",
//           default: "0",
//           label: "break",
//           required: true,
//           minimum: 0,
//           maximum: 60,
//           view: true,
//           add: true,
//           customClass: "half",
//           update: true,
//         },
//         {
//           type: "multiSelect",
//           placeholder: "employee",
//           name: "user",
//           condition: shiftCondition,
//           tags: [
//             { item: "title", title: "place", collection: "place" },
//             { item: "title", title: "shift", collection: "shiftTemplate" },
//           ],
//           validation: "",
//           default: "",
//           label: "employee",
//           showItem: "employee",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//           apiType: "API",
//           selectApi: "user/select",
//           customClass: "half",
//         },
//         {
//           type: "textarea",
//           placeholder: "note",
//           name: "title",
//           validation: "",
//           condition: shiftCondition,
//           default: "",
//           label: "note",
//           required: false,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "info",
//           placeholder: "days",
//           name: "days",
//           validation: "",
//           default: false,
//           label: "days",
//           required: true,
//           minimum: 0,
//           maximum: 60,
//           view: true,
//           add: true,
//           update: true,
//         },

//         {
//           type: "checkbox",
//           placeholder: "reccuring",
//           condition: shiftCondition,
//           name: "reccuring",
//           validation: "",
//           default: false,
//           label: "reccuring",
//           required: true,
//           minimum: 0,
//           maximum: 60,
//           view: true,
//           add: true,
//           update: true,
//         },

//         {
//           type: "info",
//           placeholder: "days",
//           name: "days",
//           content: "selectDays",
//           validation: "",
//           condition: condition,
//           default: false,
//           label: "days",
//           required: true,
//           minimum: 0,
//           maximum: 60,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "multiSelect",
//           placeholder: "eligibleDays",
//           name: "eligibleDays",
//           listView: true,
//           validation: "",
//           default: "",
//           label: "eligibleDays",
//           required: true,
//           view: true,
//           condition: condition,
//           customClass: "half",
//           add: true,
//           update: true,
//           apiType: "JSON",
//           selectApi: [
//             { value: t("Monday"), id: "monday" },
//             { value: t("Tuesday"), id: "tuesday" },
//             { value: t("Wednesday"), id: "wednesday" },
//             { value: t("Thursday"), id: "thursday" },
//             { value: t("Friday"), id: "friday" },
//             { value: t("Saturday"), id: "saturday" },
//             { value: t("Sunday"), id: "sunday" },
//           ],
//         },
//         {
//           type: "date",
//           placeholder: "scheduleEnd",
//           name: "endDate",
//           validation: "",
//           customClass: "half",
//           condition: condition,
//           greater: "startDate",
//           minDate: date.clone().add(1, "days"),
//           maxDate: date.clone().add(3, "months"),
//           default: date.clone().startOf("day").add(15, "hours"),
//           label: "scheduleEnd",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//         },
//       ]);
//     }
//     setIsAddNewSchedule(true);
//     // const addVal = addValues;
//     // setAddValues(addVal);
//   };
//   const addNewOpenServiceSchedule = (entry, item) => {
//     let date = moment(entry.originalDate);
//     setSaveApiUrl("shift/addOpenServiceShift");
//     setTitle("openServices");
//     if (item.placeId) {
//       // setUserId(item._id);
//       setAddAttributes([
//         // {
//         //   type: "title",
//         //   name: "scheduleTo",
//         //   validation: "",
//         //   title: t("scheduleFor", { name: item.fullName }),
//         //   label: "scheduleTo",
//         //   view: true,
//         //   add: true,
//         //   update: true,
//         // },
//         // {
//         //   type: "info",
//         //   name: "scheduleTo",
//         //   validation: "",
//         //   title: ``,
//         //   label: "scheduleTo",
//         //   view: true,
//         //   add: true,
//         //   update: true,
//         // },
//         {
//           type: "select",
//           placeholder: "shift",
//           name: "shiftTemplate",
//           validation: "",
//           updateCondition: [
//             { item: "shiftStart", value: "shiftStart" },
//             { item: "shiftEnd", value: "shiftEnd" },
//             { item: "startBuffer", value: "startBuffer" },
//             { item: "endBuffer", value: "endBuffer" },
//             { item: "break", value: "break" },
//           ],
//           tags: [
//             { type: "time", item: "shiftStart", title: "shiftStart", collection: "" },
//             { type: "time", item: "shiftEnd", title: "shiftEnd", collection: "" },
//           ],
//           default: "",
//           label: "shift",
//           showItem: "title",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//           apiType: "API",
//           selectApi: "shift/select",
//           customClass: "half",
//         },
//         {
//           type: "hidden",
//           placeholder: "place",
//           name: "place",
//           validation: "",
//           condition: shiftCondition,
//           default: [[item.placeId]],
//           label: "place",
//           showItem: "title",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//           apiType: "API",
//           selectApi: "place/select",
//           customClass: "half",
//         },

        
//         {
//           type: "date",
//           placeholder: "scheduleDate",
//           condition: shiftCondition,
//           name: "startDate",
//           validation: "",
//           default: moment(entry.date).startOf("day").add(7, "hours"),
//           label: "scheduleDate",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "time",
//           placeholder: "shiftStart",
//           name: "shiftStart",
//           validation: "",
//           condition: shiftCondition,
//           default: date.clone().add(7, "hours"),
//           label: "shiftStart",
//           required: true,
//           interval: 15,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "time",
//           placeholder: "shiftEnd",
//           name: "shiftEnd",
//           condition: shiftCondition,
//           validation: "",
//           default: date.clone().add(19, "hours"),
//           label: "shiftEnd",
//           required: true,
//           interval: 15,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "number",
//           placeholder: "startBuffer",
//           condition: shiftCondition,
//           name: "startBuffer",
//           validation: "",
//           default: "",
//           showItem: "value",
//           label: "startBuffer",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//           customClass: "half",
//           filter: false,
//           apiType: "JSON",
//           selectApi: [
//             { value: "10 minutes", id: 10 },
//             { value: "15 minutes", id: 15 },
//             { value: "20 minutes", id: 20 },
//             { value: "25 minutes", id: 25 },
//             { value: "30 minutes", id: 30 },
//             { value: "45 minutes", id: 45 },
//             { value: "60 minutes", id: 60 },
//           ],
//         },
//         {
//           type: "number",
//           placeholder: "endBuffer",
//           condition: shiftCondition,
//           name: "endBuffer",
//           validation: "",
//           default: "",
//           showItem: "value",
//           label: "endBuffer",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//           customClass: "half",
//           filter: false,
//           apiType: "JSON",
//           selectApi: [
//             { value: "10 minutes", id: 10 },
//             { value: "15 minutes", id: 15 },
//             { value: "20 minutes", id: 20 },
//             { value: "25 minutes", id: 25 },
//             { value: "30 minutes", id: 30 },
//             { value: "45 minutes", id: 45 },
//             { value: "60 minutes", id: 60 },
//           ],
//         },
//         {
//           type: "number",
//           placeholder: "break",
//           condition: shiftCondition,
//           name: "break",
//           validation: "",
//           default: "0",
//           label: "break",
//           required: true,
//           minimum: 0,
//           maximum: 60,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "number",
//           placeholder: "serviceCount",
//           condition: shiftCondition,
//           name: "serviceCount",
//           validation: "",
//           default: "",
//           showItem: "value",
//           label: "serviceCount",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//           customClass: "half",
//         },
//         // {
//         //   type: "select",
//         //   placeholder: "employee",
//         //   name: "user",
//         //   condition: shiftCondition,
//         //   tags: [
//         //     { item: "title", title: "place", collection: "place" },
//         //     { item: "title", title: "shift", collection: "shiftTemplate" },
//         //   ],
//         //   validation: "",
//         //   default: "",
//         //   label: "employee",
//         //   showItem: "employee",
//         //   required: false,
//         //   view: true,
//         //   add: true,
//         //   update: true,
//         //   apiType: "API",
//         //   selectApi: "user/select",
//         //   customClass: "half",
//         // },
//         {
//           type: "textarea",
//           placeholder: "note",
//           name: "title",
//           validation: "",
//           condition: shiftCondition,
//           default: "",
//           label: "note",
//           required: false,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "info",
//           placeholder: "days",
//           name: "days",
//           validation: "",
//           default: false,
//           label: "days",
//           required: true,
//           minimum: 0,
//           maximum: 60,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "checkbox",
//           placeholder: "reccuring",
//           condition: shiftCondition,
//           name: "reccuring",
//           validation: "",
//           default: false,
//           label: "reccuring",
//           required: true,
//           minimum: 0,
//           maximum: 60,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "info",
//           placeholder: "days",
//           name: "days",
//           content: "selectDays",
//           validation: "",
//           condition: condition,
//           default: false,
//           label: "days",
//           required: true,
//           minimum: 0,
//           maximum: 60,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "info",
//           placeholder: "days",
//           name: "days",
//           validation: "",
//           default: false,
//           label: "days",
//           required: true,
//           minimum: 0,
//           maximum: 60,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "multiSelect",
//           placeholder: "eligibleDays",
//           listView: true,
//           name: "eligibleDays",
//           validation: "",
//           default: "",
//           label: "eligibleDays",
//           required: true,
//           view: true,
//           condition: condition,
//           customClass: "half",
//           add: true,
//           update: true,
//           apiType: "JSON",
//           selectApi: [
//             { value: t("Monday"), id: "monday" },
//             { value: t("Tuesday"), id: "tuesday" },
//             { value: t("Wednesday"), id: "wednesday" },
//             { value: t("Thursday"), id: "thursday" },
//             { value: t("Friday"), id: "friday" },
//             { value: t("Saturday"), id: "saturday" },
//             { value: t("Sunday"), id: "sunday" },
//           ],
//         },
//         {
//           type: "date",
//           placeholder: "scheduleEnd",
//           name: "endDate",
//           validation: "",
//           condition: condition,
//           greater: "startDate",
//           minDate: date.clone().add(1, "days"),
//           maxDate: date.clone().add(3, "months"),
//           default: date.clone().startOf("day").add(15, "hours"),
//           label: "scheduleEnd",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//         },
//       ]);
//     } else {
//       setAddAttributes([
//         {
//           type: "select",
//           placeholder: "shift",
//           name: "shiftTemplate",
//           validation: "",
//           updateCondition: [
//             { item: "shiftStart", value: "shiftStart" },
//             { item: "shiftEnd", value: "shiftEnd" },
//             { item: "startBuffer", value: "startBuffer" },
//             { item: "endBuffer", value: "endBuffer" },
//             { item: "break", value: "break" },
//           ],
//           tags: [
//             { type: "time", item: "shiftStart", title: "shiftStart", collection: "" },
//             { type: "time", item: "shiftEnd", title: "shiftEnd", collection: "" },
//           ],
//           default: "",
//           label: "shift",
//           showItem: "title",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//           apiType: "API",
//           selectApi: "shift/select",
//           customClass: "half",
//         },
//         {
//           type: "select",
//           placeholder: "place",
//           name: "place",
//           validation: "",
//           condition: shiftCondition,
//           default: "",
//           label: "place",
//           showItem: "title",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//           apiType: "API",
//           selectApi: "place/select",
//           customClass: "half",
//         },

//         {
//           type: "date",
//           placeholder: "scheduleDate",
//           condition: shiftCondition,
//           name: "startDate",
//           validation: "",
//           minDate: date.clone(),
//           maxDate: date.clone().add(3, "months"),
//           default: date.clone().startOf("day").add(7, "hours"),
//           label: "scheduleDate",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "time",
//           placeholder: "shiftStart",
//           name: "shiftStart",
//           validation: "",
//           condition: shiftCondition,
//           default: date.clone().add(7, "hours"),
//           label: "shiftStart",
//           required: true,
//           interval: 15,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "time",
//           placeholder: "shiftEnd",
//           name: "shiftEnd",
//           condition: shiftCondition,
//           validation: "",
//           default: date.clone().add(19, "hours"),
//           label: "shiftEnd",
//           required: true,
//           interval: 15,
//           view: true,
//           add: true,
//           update: true,
//         },
        
//         {
//           type: "number",
//           placeholder: "startBuffer",
//           condition: shiftCondition,
//           name: "startBuffer",
//           validation: "",
//           default: "",
//           showItem: "value",
//           label: "startBuffer",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//           customClass: "half",
//           filter: false,
//           apiType: "JSON",
//           selectApi: [
//             { value: "10 minutes", id: 10 },
//             { value: "15 minutes", id: 15 },
//             { value: "20 minutes", id: 20 },
//             { value: "25 minutes", id: 25 },
//             { value: "30 minutes", id: 30 },
//             { value: "45 minutes", id: 45 },
//             { value: "60 minutes", id: 60 },
//           ],
//         },
//         {
//           type: "number",
//           placeholder: "endBuffer",
//           condition: shiftCondition,
//           name: "endBuffer",
//           validation: "",
//           default: "",
//           showItem: "value",
//           label: "endBuffer",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//           customClass: "half",
//           filter: false,
//           apiType: "JSON",
//           selectApi: [
//             { value: "10 minutes", id: 10 },
//             { value: "15 minutes", id: 15 },
//             { value: "20 minutes", id: 20 },
//             { value: "25 minutes", id: 25 },
//             { value: "30 minutes", id: 30 },
//             { value: "45 minutes", id: 45 },
//             { value: "60 minutes", id: 60 },
//           ],
//         },
//         {
//           type: "number",
//           placeholder: "break",
//           condition: shiftCondition,
//           name: "break",
//           validation: "",
//           default: "0",
//           label: "break",
//           required: true,
//           minimum: 0,
//           maximum: 60,
//           view: true,
//           add: true,
//           customClass: "half",
//           update: true,
//         },
//         {
//           type: "number",
//           placeholder: "serviceCount",
//           condition: shiftCondition,
//           name: "serviceCount",
//           validation: "",
//           default: "",
//           showItem: "value",
//           label: "serviceCount",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//           customClass: "half",
//         },
//         // {
//         //   type: "select",
//         //   placeholder: "employee",
//         //   name: "user",
//         //   condition: shiftCondition,
//         //   tags: [
//         //     { item: "title", title: "place", collection: "place" },
//         //     { item: "title", title: "shift", collection: "shiftTemplate" },
//         //   ],
//         //   validation: "",
//         //   default: "",
//         //   label: "employee",
//         //   showItem: "employee",
//         //   required: false,
//         //   view: true,
//         //   add: true,
//         //   update: true,
//         //   apiType: "API",
//         //   selectApi: "user/select",
//         //   customClass: "half",
//         // },
//         {
//           type: "textarea",
//           placeholder: "note",
//           name: "title",
//           validation: "",
//           condition: shiftCondition,
//           default: "",
//           label: "note",
//           required: false,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "info",
//           placeholder: "days",
//           name: "days",
//           validation: "",
//           default: false,
//           label: "days",
//           required: true,
//           minimum: 0,
//           maximum: 60,
//           view: true,
//           add: true,
//           update: true,
//         },

//         {
//           type: "checkbox",
//           placeholder: "reccuring",
//           condition: shiftCondition,
//           name: "reccuring",
//           validation: "",
//           default: false,
//           label: "reccuring",
//           required: true,
//           minimum: 0,
//           maximum: 60,
//           view: true,
//           add: true,
//           update: true,
//         },

//         {
//           type: "info",
//           placeholder: "days",
//           name: "days",
//           content: "selectDays",
//           validation: "",
//           condition: condition,
//           default: false,
//           label: "days",
//           required: true,
//           minimum: 0,
//           maximum: 60,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "multiSelect",
//           placeholder: "eligibleDays",
//           name: "eligibleDays",
//           listView: true,
//           validation: "",
//           default: "",
//           label: "eligibleDays",
//           required: true,
//           view: true,
//           condition: condition,
//           customClass: "half",
//           add: true,
//           update: true,
//           apiType: "JSON",
//           selectApi: [
//             { value: t("Monday"), id: "monday" },
//             { value: t("Tuesday"), id: "tuesday" },
//             { value: t("Wednesday"), id: "wednesday" },
//             { value: t("Thursday"), id: "thursday" },
//             { value: t("Friday"), id: "friday" },
//             { value: t("Saturday"), id: "saturday" },
//             { value: t("Sunday"), id: "sunday" },
//           ],
//         },
//         {
//           type: "date",
//           placeholder: "scheduleEnd",
//           name: "endDate",
//           validation: "",
//           customClass: "half",
//           condition: condition,
//           greater: "startDate",
//           minDate: date.clone().add(1, "days"),
//           maxDate: date.clone().add(3, "months"),
//           default: date.clone().startOf("day").add(15, "hours"),
//           label: "scheduleEnd",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//         },
//       ]);
//     }
//     setIsAddNewSchedule(true);
//     // const addVal = addValues;
//     // setAddValues(addVal);
//   };
//   const addNewAbsence = (entry, item) => {
//     let date = moment(entry.originalDate ?? new Date());
//     setTitle("absence");
//     setSaveApiUrl("user/addAbsence");
//     setAddAttributes([
//       {
//         type: "date",
//         placeholder: "scheduleDate",
//         name: "startDate",
//         customClass: "half",
//         validation: "",
//         minDate: date.clone(),
//         maxDate: date.clone().add(3, "months"),
//         default: date.clone().startOf("day").add(7, "hours"),
//         label: "scheduleDate",
//         required: true,
//         view: true,
//         add: true,
//         update: true,
//       },
//       {
//         type: "date",
//         placeholder: "scheduleEnd",
//         name: "endDate",
//         validation: "",
//         customClass: "half",
//         greater: "startDate",
//         minDate: date.clone().add(1, "days"),
//         maxDate: date.clone().add(3, "months"),
//         default: date.clone().startOf("day").add(15, "hours"),
//         label: "scheduleEnd",
//         required: true,
//         view: true,
//         add: true,
//         update: true,
//       },
//       {
//         type: "multiSelect",
//         placeholder: "employee",
//         name: "user",
//         condition: shiftCondition,
//         tags: [
//           { item: "title", title: "place", collection: "place" },
//           { item: "title", title: "shift", collection: "shiftTemplate" },
//         ],
//         validation: "",
//         default: "",
//         label: "employee",
//         showItem: "employee",
//         required: true,
//         view: true,
//         add: true,
//         update: true,
//         apiType: "API",
//         selectApi: "user/select",
//         customClass: "half",
//       },
//       {
//         type: "select",
//         placeholder: "leaveType",
//         name: "leaveType",
//         validation: "",
//         default: "",
//         label: "leaveType",
//         showItem: "locale",
//         required: true,
//         view: true,
//         add: true,
//         update: true,
//         apiType: "API",
//         selectApi: "leave-type/select",
//         customClass: "half",
//       },
//       {
//         type: "textarea",
//         placeholder: "notes",
//         name: "note",
//         validation: "",
//         default: "",
//         label: "notes",
//         required: false,
//         view: true,
//         add: true,
//         update: true,
//       },
//     ]);

//     setIsAddNewSchedule(true);
//   };
//   const addNEmployeesToRequiredSchedule = (entry, item) => {
//     setTitle("assignEmployees");
//     setSaveApiUrl("shift/assignEmployees");
//     setAddAttributes([
//       {
//         type: "multiSelect",
//         placeholder: "employee",
//         name: "user",
//         condition: shiftCondition,
//         tags: [
//           { item: "title", title: "place", collection: "place" },
//           { item: "title", title: "shift", collection: "shiftTemplate" },
//         ],
//         validation: "",
//         default: "",
//         label: "employee",
//         showItem: "employee",
//         required: true,
//         view: true,
//         add: true,
//         update: true,
//         apiType: "API",
//         selectApi: "user/select",
//         customClass: "half",
//       },
//       {
//         type: "hidden",
//         placeholder: "requiredShift",
//         name: "requiredShift",
//         validation: "",
//         default: entry._id,
//         label: "requiredShift",
//         required: true,
//         view: true,
//         add: true,
//         update: true,
//       },
//     ]);
//     setIsAddNewSchedule(true);
//   };
//   const addNewRequiredSchedule = (entry, item) => {
//     let date = moment(entry.originalDate ?? new Date());
//     setTitle("requiredShift");
//     setSaveApiUrl("shift/addRequiredShift");
//     setAddAttributes([
//       {
//         type: "select",
//         placeholder: "shift",
//         name: "shiftTemplate",
//         validation: "",
//         updateCondition: [
//           { item: "shiftStart", value: "shiftStart" },
//           { item: "shiftEnd", value: "shiftEnd" },
//           { item: "break", value: "break" },
//         ],
//         tags: [
//           { type: "time", item: "shiftStart", title: "shiftStart", collection: "" },
//           { type: "time", item: "shiftEnd", title: "shiftEnd", collection: "" },
//         ],
//         default: "",
//         label: "shift",
//         showItem: "title",
//         required: true,
//         view: true,
//         add: true,
//         update: true,
//         apiType: "API",
//         selectApi: "shift/select",
//         customClass: "half",
//       },
//       {
//         type: "select",
//         placeholder: "place",
//         name: "place",
//         validation: "",
//         condition: shiftCondition,
//         default: "",
//         label: "place",
//         showItem: "title",
//         required: true,
//         view: true,
//         add: true,
//         update: true,
//         apiType: "API",
//         selectApi: "place/select",
//         customClass: "half",
//       },
//       {
//         type: "date",
//         placeholder: "scheduleDate",
//         condition: shiftCondition,
//         name: "startDate",
//         validation: "",
//         minDate: date.clone(),
//         maxDate: date.clone().add(3, "months"),
//         default: date.clone().startOf("day").add(7, "hours"),
//         label: "scheduleDate",
//         required: true,
//         view: true,
//         add: true,
//         update: true,
//       },
//       {
//         type: "number",
//         placeholder: "break",
//         condition: shiftCondition,
//         name: "break",
//         validation: "",
//         default: "0",
//         label: "break",
//         required: true,
//         minimum: 0,
//         maximum: 60,
//         view: true,
//         add: true,
//         customClass: "half",
//         update: true,
//       },
//       {
//         type: "time",
//         placeholder: "shiftStart",
//         name: "shiftStart",
//         validation: "",
//         condition: shiftCondition,
//         default: date.clone().startOf("day").add(7, "hours"),
//         label: "shiftStart",
//         required: true,
//         interval: 15,
//         view: true,
//         add: true,
//         update: true,
//       },
//       {
//         type: "time",
//         placeholder: "shiftEnd",
//         name: "shiftEnd",
//         condition: shiftCondition,
//         validation: "",
//         default: date.clone().startOf("day").add(19, "hours"),
//         label: "shiftEnd",
//         required: true,
//         interval: 15,
//         view: true,
//         add: true,
//         update: true,
//       },
//       {
//         type: "select",
//         placeholder: "requiredShift",
//         condition: shiftCondition,
//         name: "requiredType",
//         validation: "",
//         default: "",
//         showItem: "value",
//         label: "requiredShift",
//         required: true,
//         view: true,
//         add: true,
//         update: true,
//         customClass: "half",
//         filter: false,
//         apiType: "JSON",
//         selectApi: [
//           { value: t("At least"), id: "At least" },
//           { value: t("At most"), id: "At most" },
//           { value: t("Exactly"), id: "Exactly" },
//         ],
//       },
//       {
//         type: "number",
//         placeholder: "serviceCount",
//         condition: shiftCondition,
//         name: "serviceCount",
//         validation: "",
//         default: "",
//         showItem: "value",
//         label: "serviceCount",
//         required: true,
//         view: true,
//         add: true,
//         update: true,
//       },
//       {
//         type: "select",
//         placeholder: "timeSettings",
//         condition: shiftCondition,
//         name: "timeSettings",
//         validation: "",
//         default: "",
//         showItem: "value",
//         label: "timeSettings",
//         required: true,
//         view: true,
//         add: true,
//         update: true,
//         customClass: "half",
//         filter: false,
//         apiType: "JSON",
//         selectApi: [
//           { id: "any", value: t("any") },
//           { id: "outside", value: t("outside") },
//           { id: "starting", value: t("starting") },
//           { id: "ending", value: t("ending") },
//           { id: "exact", value: t("exact") },
//         ],
//       },
//       // {
//       //   type: "multiSelect",
//       //   placeholder: "employee",
//       //   name: "user",
//       //   condition: shiftCondition,
//       //   tags: [
//       //     { item: "title", title: "place", collection: "place" },
//       //     { item: "title", title: "shift", collection: "shiftTemplate" },
//       //   ],
//       //   validation: "",
//       //   default: "",
//       //   label: "employee",
//       //   showItem: "employee",
//       //   required: true,
//       //   view: true,
//       //   add: true,
//       //   update: true,
//       //   apiType: "API",
//       //   selectApi: "user/select",
//       //   customClass: "half",
//       // },
//       {
//         type: "textarea",
//         placeholder: "note",
//         name: "title",
//         validation: "",
//         condition: shiftCondition,
//         default: "",
//         label: "note",
//         required: false,
//         view: true,
//         add: true,
//         update: true,
//       },
//       {
//         type: "info",
//         placeholder: "days",
//         name: "days",
//         validation: "",
//         default: false,
//         label: "days",
//         required: true,
//         minimum: 0,
//         maximum: 60,
//         view: true,
//         add: true,
//         update: true,
//       },
//       {
//         type: "checkbox",
//         placeholder: "reccuring",
//         condition: shiftCondition,
//         name: "reccuring",
//         validation: "",
//         default: false,
//         label: "reccuring",
//         required: true,
//         minimum: 0,
//         maximum: 60,
//         view: true,
//         add: true,
//         update: true,
//       },
//       {
//         type: "info",
//         placeholder: "days",
//         name: "days",
//         content: "selectDays",
//         validation: "",
//         condition: condition,
//         default: false,
//         label: "days",
//         required: true,
//         minimum: 0,
//         maximum: 60,
//         view: true,
//         add: true,
//         update: true,
//       },
//       {
//         type: "info",
//         placeholder: "days",
//         name: "days",
//         content: "",
//         validation: "",
//         condition: condition,
//         default: false,
//         label: "days",
//         required: true,
//         minimum: 0,
//         maximum: 60,
//         view: true,
//         add: true,
//         update: true,
//       },
//       {
//         type: "multiSelect",
//         placeholder: "eligibleDays",
//         listView: true,
//         name: "eligibleDays",
//         validation: "",
//         default: "",
//         label: "eligibleDays",
//         required: true,
//         view: true,
//         condition: condition,
//         customClass: "half",
//         add: true,
//         update: true,
//         apiType: "JSON",
//         selectApi: [
//           { value: t("Monday"), id: "monday" },
//           { value: t("Tuesday"), id: "tuesday" },
//           { value: t("Wednesday"), id: "wednesday" },
//           { value: t("Thursday"), id: "thursday" },
//           { value: t("Friday"), id: "friday" },
//           { value: t("Saturday"), id: "saturday" },
//           { value: t("Sunday"), id: "sunday" },
//         ],
//       },
//       {
//         type: "date",
//         placeholder: "scheduleEnd",
//         name: "endDate",
//         validation: "",
//         customClass: "half",
//         condition: condition,
//         greater: "startDate",
//         minDate: date.clone().add(1, "days"),
//         maxDate: date.clone().add(3, "months"),
//         default: date.clone().startOf("day").add(15, "hours"),
//         label: "scheduleEnd",
//         required: true,
//         view: true,
//         add: true,
//         update: true,
//       },
//     ]);

//     setIsAddNewSchedule(true);
//     // const addVal = addValues;
//     // setAddValues(addVal);
//   };
//   const editAbsence = async (entry, item, scheduleIndex, absence, isDeleted = false, openDataTemp = {}) => {
//     let date = absence.date ? moment(absence.date): moment(new Date())
//     if (isDeleted) {
//       setMessage({
//         type: 2,
//         content: t("deleteRequest", { label: t("absence") }),
//         proceed: t("delete"),
//         onProceed: async () => {
//           const loadedDataTemp = { ...loadedData };
//           const deleteData = { ...absence, isDeleted: isDeleted }; // Create a copy of loadedData
//           try {
//             const { place, dayIndex, userIndex } = openDataTemp;
//             const response = await postData(deleteData, "user/updateAbsence");
//             const schedules = loadedDataTemp.data.userData[place].users[userIndex].absences[dayIndex]?.items ?? null;
//             if (response.status === 200) {
//               if (schedules) {
//                 delete schedules[scheduleIndex];
//               }
//               loadedDataTemp.data.isPublished = false;
//             }
//           } catch (error) {
//             alert(error);
//           }
//           setLoaderBox(false);
//           setLoadedData(loadedDataTemp);
//         },
//       });
//     } else {
//       setSelectedSchedule({ ...absence, isDeleted: isDeleted });
//       setUpdateApiUrl("user/updateAbsence");
//       setAddOverrideUpdate([
//         {
//           type: "date",
//           placeholder: "Date",
//           name: "date",
//           validation: "",
//           customClass: "half",
//           minDate: date.clone(),
//           maxDate: date.clone().add(3, "months"),
//           default: date.clone().startOf("day").add(7, "hours"),
//           label: "Date",
//           required: true,
//           view: true,
//           add: false,
//           update: false,
//         },
//         {
//           type: "select",
//           placeholder: "leaveType",
//           name: "leaveType",
//           validation: "",
//           customClass: "half",
//           default: "",
//           collection: "leaveType",
//           label: "leaveType",
//           showItem: "locale",
//           required: true,
//           view: true,
//           add: false,
//           update: false,
//           apiType: "API",
//           selectApi: "leave-type/select",
//         },
//         {
//           type: "select",
//           placeholder: "approval",
//           name: "approval",
//           validation: "",
//           customClass: "half",
//           default: "",
//           label: "approval",
//           required: true,
//           apiType: "JSON",
//           selectApi: [
//             { id: "Confirmed", value: t("Confirmed") },
//             { id: "Rejected", value: t("Rejected") },
//           ],
//           view: false,
//           add: false,
//           update: false,
//         },
//         {
//           type: "textarea",
//           placeholder: "note",
//           name: "note",
//           validation: "",
//           default: "",
//           label: "note",
//           required: false,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "hidden",
//           placeholder: "scheduleUser",
//           name: "_id",
//           validation: "",
//           default: absence._id,
//           label: "scheduleUser",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "hidden",
//           placeholder: "scheduleUser",
//           name: "user",
//           validation: "",
//           default: absence.user,
//           label: "scheduleUser",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "info",
//           condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
//           name: "deleteSchedule",
//           validation: "",
//           content: "Check below to delete this schedule",
//           label: "deleteSchedule",
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "info",
//           condition: { item: "isDeleted", if: true, then: "enabled", else: "disabled" },
//           name: "deleteSchedule",
//           validation: "",
//           content: "deleteWarning",
//           label: "deleteSchedule",
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "checkbox",
//           placeholder: "delete",
//           name: "isDeleted",
//           validation: "",
//           default: false,
//           label: "delete",
//           required: true,
//           minimum: 0,
//           maximum: 60,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "hidden",
//           placeholder: "absenceGroup",
//           name: "absenceGroup",
//           validation: "",
//           default: absence.absenceGroup,
//           label: "absenceGroup",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "info",
//           condition: { item: "deleteAll", if: true, then: "enabled", else: "disabled" },
//           name: "deleteSchedule",
//           validation: "",
//           content: "deleteAllWarning",
//           label: "deleteSchedule",
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "checkbox",
//           placeholder: "deleteAll",
//           name: "deleteAll",
//           validation: "",
//           condition: { item: "isDeleted", if: true, then: "enabled", else: "disabled" },
//           default: false,
//           label: "deleteAll",
//           required: true,
//           minimum: 0,
//           maximum: 60,
//           view: true,
//           add: true,
//           update: true,
//         },
//       ]);
//       setModifySchedule(true);
//     }
//   };
//   const editSchedule = async (entry, item, scheduleIndex, schedule, isDeleted = false, openDataTemp = {}) => {
//     // Use formattedOriginalDate as the default value for scheduleDate

//     if (isDeleted) {
//       setMessage({
//         type: 2,
//         content: t("deleteRequest", { label: t("layer") }),
//         proceed: t("delete"),
//         onProceed: async () => {
//           const loadedDataTemp = { ...loadedData };
//           const deleteData = { ...schedule, isDeleted: isDeleted }; // Create a copy of loadedData
//           try {
//             const { place, dayIndex, userIndex } = openDataTemp;
//             const response = await postData(deleteData, "shift/updateSingleSchedule");
//             const schedules = loadedDataTemp.data.userData[place].users[userIndex].schedulesDates[dayIndex];
//             if (response.status === 200) {
//               if (schedules?.items?.length > 1) {
//                 delete schedules.items[scheduleIndex];
//               } else {
//                 delete schedules.items;
//               }
//               if(loadedDataTemp?.data?.publishCount){
//                 loadedDataTemp.data.publishCount += 1;
//               }else{
//                 loadedDataTemp.data.publishCount = 1;
//               }
//             }
//           } catch (error) {
//             alert(error);
//           }
//           setLoaderBox(false);
//           setLoadedData(loadedDataTemp);
//         },
//       });
//     } else {
//       setSelectedSchedule({ ...schedule, isDeleted: isDeleted });
//       setUpdateApiUrl("shift/updateSingleSchedule");
//       setAddOverrideUpdate([
//         {
//           type: "time",
//           placeholder: "startTime",
//           condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
//           name: "startTime",
//           validation: "",
//           default: schedule.startTime,
//           label: "startTime",
//           required: true,
//           interval: 15,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "time",
//           placeholder: "endTime",
//           name: "endTime",
//           condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
//           validation: "",
//           default: schedule.endTime,
//           label: "endTime",
//           required: true,
//           interval: 15,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "number",
//           placeholder: "startBuffer",
//           condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
//           name: "startBuffer",
//           validation: "",
//           default: schedule.startBuffer,
//           showItem: "value",
//           label: "startBuffer",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//           customClass: "half",
//           filter: false,
//           apiType: "JSON",
//           selectApi: [
//             { value: "10 minutes", id: 10 },
//             { value: "15 minutes", id: 15 },
//             { value: "20 minutes", id: 20 },
//             { value: "25 minutes", id: 25 },
//             { value: "30 minutes", id: 30 },
//             { value: "45 minutes", id: 45 },
//             { value: "60 minutes", id: 60 },
//           ],
//         },
//         {
//           type: "number",
//           placeholder: "endBuffer",
//           condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
//           name: "endBuffer",
//           validation: "",
//           default: schedule.endBuffer,
//           showItem: "value",
//           label: "endBuffer",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//           customClass: "half",
//           filter: false,
//           apiType: "JSON",
//           selectApi: [
//             { value: "10 minutes", id: 10 },
//             { value: "15 minutes", id: 15 },
//             { value: "20 minutes", id: 20 },
//             { value: "25 minutes", id: 25 },
//             { value: "30 minutes", id: 30 },
//             { value: "45 minutes", id: 45 },
//             { value: "60 minutes", id: 60 },
//           ],
//         },
//         {
//           type: "number",
//           condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
//           placeholder: "break",
//           name: "break",
//           validation: "",
//           default: schedule.break,
//           label: "break",
//           required: true,
//           minimum: 0,
//           maximum: 60,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "hidden",
//           placeholder: "scheduleUser",
//           name: "_id",
//           validation: "",
//           default: schedule._id,
//           label: "scheduleUser",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "hidden",
//           placeholder: "scheduleUser",
//           name: "shiftSchedule",
//           validation: "",
//           default: schedule.shiftSchedule,
//           label: "scheduleUser",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "hidden",
//           placeholder: "scheduleUser",
//           name: "user",
//           validation: "",
//           default: schedule.user,
//           label: "scheduleUser",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "info",
//           condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
//           name: "deleteSchedule",
//           validation: "",
//           content: "Check below to delete this schedule",
//           label: "deleteSchedule",
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "info",
//           condition: { item: "isDeleted", if: true, then: "enabled", else: "disabled" },
//           name: "deleteSchedule",
//           validation: "",
//           content: "deleteWarning",
//           label: "deleteSchedule",
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "checkbox",
//           placeholder: "delete",
//           name: "isDeleted",
//           validation: "",
//           default: false,
//           label: "delete",
//           required: true,
//           minimum: 0,
//           maximum: 60,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "info",
//           condition: { item: "deleteAll", if: true, then: "enabled", else: "disabled" },
//           name: "deleteSchedule",
//           validation: "",
//           content: "deleteAllWarning",
//           label: "deleteSchedule",
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "checkbox",
//           placeholder: "deleteAll",
//           name: "deleteAll",
//           validation: "",
//           condition: { item: "isDeleted", if: true, then: "enabled", else: "disabled" },
//           default: false,
//           label: "deleteAll",
//           required: true,
//           minimum: 0,
//           maximum: 60,
//           view: true,
//           add: true,
//           update: true,
//         },
//       ]);
//       setModifySchedule(true);
//     }
//     // const addVal = addValues;
//     // setAddValues(addVal);
//   };
//   const editrequiredShift = (entry, item, scheduleIndex, schedule, isDeleted = false, openDataTemp = {}) => {
//     if (isDeleted) {
//       setMessage({
//         type: 2,
//         content: t("deleteRequest", { label: t("requiredShift") }),
//         proceed: t("delete"),
//         onProceed: async () => {
//           const loadedDataTemp = { ...loadedData };
//           const deleteData = { ...schedule, isDeleted: isDeleted }; // Create a copy of loadedData
//           try {
//             const { place, dayIndex } = openDataTemp;
//             const response = await postData(deleteData, "shift/updateSingleRequiredShift");
//             const schedules = loadedDataTemp.data.userData[place].requiredShifts[dayIndex] ?? null;
//             if (response.status === 200) {
//               if (schedules?.items?.length > 1) {
//                 delete schedules.items[scheduleIndex];
//               } else {
//                 delete schedules.items;
//               }
//               loadedDataTemp.data.isPublished = false;
//               if(loadedDataTemp?.data?.publishCount){
//                 loadedDataTemp.data.publishCount += 1;
//               }else{
//                 loadedDataTemp.data.publishCount = 1;
//               }
//             }
//           } catch (error) {
//             alert(error);
//           }
//           setLoaderBox(false);
//           setLoadedData(loadedDataTemp);
//         },
//       });
//     } else {
//       // Use formattedOriginalDate as the default value for scheduleDate
//       setUpdateApiUrl("shift/updateSingleRequiredShift");
//       setSelectedSchedule(schedule);
//       let date = moment(schedule.startDate ?? new Date());
//       setAddOverrideUpdate([
//         {
//           type: "select",
//           placeholder: "shift",
//           name: "shiftTemplate",
//           validation: "",
//           updateCondition: [
//             { item: "startTime", value: "shiftStart" },
//             { item: "endTime", value: "shiftEnd" },
//             { item: "break", value: "break" },
//           ],
//           tags: [
//             { type: "time", item: "shiftStart", title: "shiftStart", collection: "" },
//             { type: "time", item: "shiftEnd", title: "shiftEnd", collection: "" },
//           ],
//           default: "",
//           label: "shift",
//           showItem: "title",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//           apiType: "API",
//           selectApi: "shift/select",
//           customClass: "half",
//         },
//         {
//           type: "select",
//           placeholder: "place",
//           name: "place",
//           validation: "",
//           condition: shiftCondition,
//           default: "",
//           label: "place",
//           showItem: "title",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//           apiType: "API",
//           selectApi: "place/select",
//           customClass: "half",
//         },
//         {
//           type: "date",
//           placeholder: "scheduleDate",
//           condition: shiftCondition,
//           name: "startDate",
//           validation: "",
//           minDate: date.clone(),
//           maxDate: date.clone().add(3, "months"),
//           default: date.clone().startOf("day").add(7, "hours"),
//           label: "scheduleDate",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "time",
//           placeholder: "startTime",
//           condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
//           name: "startTime",
//           validation: "",
//           default: schedule.startTime,
//           label: "startTime",
//           required: true,
//           interval: 15,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "time",
//           placeholder: "endTime",
//           name: "endTime",
//           condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
//           validation: "",
//           default: schedule.endTime,
//           label: "endTime",
//           required: true,
//           interval: 15,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "number",
//           condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
//           placeholder: "break",
//           name: "break",
//           validation: "",
//           default: schedule.break,
//           label: "break",
//           required: true,
//           minimum: 0,
//           maximum: 60,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "hidden",
//           placeholder: "scheduleUser",
//           name: "_id",
//           validation: "",
//           default: schedule._id,
//           label: "scheduleUser",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "hidden",
//           placeholder: "requiredShift",
//           name: "requiredShift",
//           validation: "",
//           default: schedule.requiredShift,
//           label: "requiredShift",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "select",
//           placeholder: "requiredShift",
//           condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
//           name: "requiredType",
//           validation: "",
//           default: schedule.requiredType,
//           showItem: "value",
//           label: "requiredShift",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//           customClass: "half",
//           filter: false,
//           apiType: "JSON",
//           selectApi: [
//             { value: t("At least"), id: "At least" },
//             { value: t("At most"), id: "At most" },
//             { value: t("Exactly"), id: "Exactly" },
//           ],
//         },
//         {
//           type: "number",
//           placeholder: "serviceCount",
//           name: "serviceCount",
//           condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
//           validation: "",
//           default: "",
//           showItem: "value",
//           label: "serviceCount",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "select",
//           placeholder: "timeSettings",
//           condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
//           name: "timeSettings",
//           validation: "",
//           default: "",
//           showItem: "value",
//           label: "timeSettings",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//           customClass: "half",
//           filter: false,
//           apiType: "JSON",
//           selectApi: [
//             { id: "any", value: t("any") },
//             { id: "outside", value: t("outside") },
//             { id: "starting", value: t("starting") },
//             { id: "ending", value: t("ending") },
//             { id: "exact", value: t("exact") },
//           ],
//         },

//         {
//           type: "textarea",
//           placeholder: "note",
//           name: "title",
//           validation: "",
//           condition: shiftCondition,
//           default: "",
//           label: "note",
//           required: false,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "info",
//           condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
//           name: "deleteSchedule",
//           validation: "",
//           content: "Check below to delete this schedule",
//           label: "deleteSchedule",
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "info",
//           condition: { item: "isDeleted", if: true, then: "enabled", else: "disabled" },
//           name: "deleteSchedule",
//           validation: "",
//           content: "deleteWarning",
//           label: "deleteSchedule",
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "checkbox",
//           placeholder: "delete",
//           name: "isDeleted",
//           validation: "",
//           default: false,
//           label: "delete",
//           required: true,
//           minimum: 0,
//           maximum: 60,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "info",
//           condition: { item: "deleteAll", if: true, then: "enabled", else: "disabled" },
//           name: "deleteSchedule",
//           validation: "",
//           content: "deleteAllWarning",
//           label: "deleteSchedule",
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "checkbox",
//           placeholder: "deleteAll",
//           name: "deleteAll",
//           validation: "",
//           condition: { item: "isDeleted", if: true, then: "enabled", else: "disabled" },
//           default: false,
//           label: "deleteAll",
//           required: true,
//           minimum: 0,
//           maximum: 60,
//           view: true,
//           add: true,
//           update: true,
//         },
//       ]);
//       setModifySchedule(true);
//       // const addVal = addValues;
//       // setAddValues(addVal);
//     }
//   };
//   const editopenShift = (entry, item, scheduleIndex, schedule, isDeleted = false, openDataTemp = {}) => {
//     if (isDeleted) {
//       setMessage({
//         type: 2,
//         content: t("deleteRequest", { label: t("openServices") }),
//         proceed: t("delete"),
//         onProceed: async () => {
//           const loadedDataTemp = { ...loadedData };
//           const deleteData = { ...schedule, isDeleted: isDeleted }; // Create a copy of loadedData
//           try {
//             const { place, dayIndex } = openDataTemp;
//             const response = await postData(deleteData, "shift/updateSingleOpenShift");
//             const schedules = loadedDataTemp.data.userData[place].openService[dayIndex] ?? null;
//             if (response.status === 200) {
//               if (schedules?.items?.length > 1) {
//                 delete schedules.items[scheduleIndex];
//               } else {
//                 delete schedules.items;
//               }
//               loadedDataTemp.data.isPublished = false;
//               if(loadedDataTemp?.data?.publishCount){
//                 loadedDataTemp.data.publishCount += 1;
//               }else{
//                 loadedDataTemp.data.publishCount = 1;
//               }
//             }
//           } catch (error) {
//             alert(error);
//           }
//           setLoaderBox(false);
//           setLoadedData(loadedDataTemp);
//         },
//       });
//     } else {
//       // Use formattedOriginalDate as the default value for scheduleDate
//       setUpdateApiUrl("shift/updateSingleOpenShift");
//       setSelectedSchedule(schedule);
//       let date = moment(schedule.startTime ?? new Date());
//       setAddOverrideUpdate([
//         {
//           type: "select",
//           placeholder: "shift",
//           name: "shiftTemplate",
//           validation: "",
//           updateCondition: [
//             { item: "startTime", value: "shiftStart" },
//             { item: "endTime", value: "shiftEnd" },
//             { item: "break", value: "break" },
//           ],
//           tags: [
//             { type: "time", item: "shiftStart", title: "shiftStart", collection: "" },
//             { type: "time", item: "shiftEnd", title: "shiftEnd", collection: "" },
//           ],
//           default: "",
//           label: "shift",
//           showItem: "title",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//           apiType: "API",
//           selectApi: "shift/select",
//           customClass: "half",
//         },
//         {
//           type: "select",
//           placeholder: "place",
//           name: "place",
//           validation: "",
//           condition: shiftCondition,
//           default: "",
//           label: "place",
//           showItem: "title",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//           apiType: "API",
//           selectApi: "place/select",
//           customClass: "half",
//         },
//         {
//           type: "date",
//           placeholder: "scheduleDate",
//           condition: shiftCondition,
//           name: "startDate",
//           validation: "",
//           maxDate: date.clone().add(3, "months"),
//           default: date.clone().startOf("day"),
//           label: "scheduleDate",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "time",
//           placeholder: "startTime",
//           condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
//           name: "startTime",
//           validation: "",
//           default: schedule.startTime,
//           label: "startTime",
//           required: true,
//           interval: 15,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "time",
//           placeholder: "endTime",
//           name: "endTime",
//           condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
//           validation: "",
//           default: schedule.endTime,
//           label: "endTime",
//           required: true,
//           interval: 15,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "number",
//           placeholder: "startBuffer",
//           condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
//           name: "startBuffer",
//           validation: "",
//           default: schedule.startBuffer,
//           showItem: "value",
//           label: "startBuffer",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//           customClass: "half",
//           filter: false,
//           apiType: "JSON",
//           selectApi: [
//             { value: "10 minutes", id: 10 },
//             { value: "15 minutes", id: 15 },
//             { value: "20 minutes", id: 20 },
//             { value: "25 minutes", id: 25 },
//             { value: "30 minutes", id: 30 },
//             { value: "45 minutes", id: 45 },
//             { value: "60 minutes", id: 60 },
//           ],
//         },
//         {
//           type: "number",
//           placeholder: "endBuffer",
//           condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
//           name: "endBuffer",
//           validation: "",
//           default: schedule.endBuffer,
//           showItem: "value",
//           label: "endBuffer",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//           customClass: "half",
//           filter: false,
//           apiType: "JSON",
//           selectApi: [
//             { value: "10 minutes", id: 10 },
//             { value: "15 minutes", id: 15 },
//             { value: "20 minutes", id: 20 },
//             { value: "25 minutes", id: 25 },
//             { value: "30 minutes", id: 30 },
//             { value: "45 minutes", id: 45 },
//             { value: "60 minutes", id: 60 },
//           ],
//         },
//         {
//           type: "number",
//           condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
//           placeholder: "break",
//           name: "break",
//           validation: "",
//           default: schedule.break,
//           label: "break",
//           required: true,
//           minimum: 0,
//           maximum: 60,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "hidden",
//           placeholder: "scheduleUser",
//           name: "_id",
//           validation: "",
//           default: schedule._id,
//           label: "scheduleUser",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "number",
//           placeholder: "serviceCount",
//           name: "serviceCount",
//           condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
//           validation: "",
//           default: "",
//           showItem: "value",
//           label: "serviceCount",
//           required: true,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "textarea",
//           placeholder: "note",
//           name: "title",
//           validation: "",
//           condition: shiftCondition,
//           default: "",
//           label: "note",
//           required: false,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "info",
//           condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
//           name: "deleteSchedule",
//           validation: "",
//           content: "Check below to delete this schedule",
//           label: "deleteSchedule",
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "info",
//           condition: { item: "isDeleted", if: true, then: "enabled", else: "disabled" },
//           name: "deleteSchedule",
//           validation: "",
//           content: "deleteWarning",
//           label: "deleteSchedule",
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "checkbox",
//           placeholder: "delete",
//           name: "isDeleted",
//           validation: "",
//           default: false,
//           label: "delete",
//           required: true,
//           minimum: 0,
//           maximum: 60,
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "info",
//           condition: { item: "deleteAll", if: true, then: "enabled", else: "disabled" },
//           name: "deleteSchedule",
//           validation: "",
//           content: "deleteAllWarning",
//           label: "deleteSchedule",
//           view: true,
//           add: true,
//           update: true,
//         },
//         {
//           type: "checkbox",
//           placeholder: "deleteAll",
//           name: "deleteAll",
//           validation: "",
//           condition: { item: "isDeleted", if: true, then: "enabled", else: "disabled" },
//           default: false,
//           label: "deleteAll",
//           required: true,
//           minimum: 0,
//           maximum: 60,
//           view: true,
//           add: true,
//           update: true,
//         },
//       ]);
//       setModifySchedule(true);
//       // const addVal = addValues;
//       // setAddValues(addVal);
//     }
//   };
//   const submitHandler = async (data) => {
//     setLoaderBox(true);
//     await postData(data, saveApiUrl)
//       .then((response) => {
//         if (response.status === 200) {
//           setMessage({ type: 1, content: t(response.data.message), proceed: "Okay" });
//           refreshView(currentIndex);
//           setIsAddNewSchedule(false);
//         } else if (response.status === 404) {
//           setMessage({ type: 1, content: t(response.data), proceed: "Okay" });
//         } else {
//           setMessage({ type: 1, content: t(response.data), proceed: "Okay" });
//         }
//         setLoaderBox(false);
//       })
//       .catch((error) => {
//         alert(error);
//         setLoaderBox(false);
//       });
  
//   };

//   const updateStatusToOpenShift = (status="pending", item, schedule,openDataTemp) => {
//     setMessage({
//       type: 2,
//       content: t("statusRequest", { label: t(status) }),
//       proceed: t("confirmed"),
//       onProceed: async () => {
//         const loadedDataTemp = { ...loadedData };
//         const updatedData = { ...schedule, userApplicationStatus:{status} }; // Create a copy of loadedData
//         const payloadData = {}
//         try {
//           const { place, userIndex, dayIndex, scheduleIndex } = openDataTemp;
//           const response = await postData({id: schedule._id,userId:item._id, status}, "shift/updateOpenShiftStatus");
//           const schedules = loadedDataTemp.data.userData[place].users[userIndex].openShifts[dayIndex] ?? null;
//           if (response.status === 200) {
//             loadedDataTemp.data.userData[place].users[userIndex].openShifts[dayIndex].items[scheduleIndex] = updatedData;
//             refreshView();
//           }
//         } catch (error) {
//           alert(error);
//         }
//         setLoaderBox(false);
//         setLoadedData(loadedDataTemp);
//       },
//     });
//   }

//   const updateHandler = async (data) => {
//     setLoaderBox(true);

//     await postData(data, updateApiUrl)
//       .then((response) => {
//         if (response.status === 200) {
//           // setMessage({ type: 1, content: t(response.data.message), proceed: "Okay" });
//           if (updateApiUrl === "shift/updateSingleSchedule") {
//             const loadedDataTemp = loadedData;
//             const schedules = loadedDataTemp.data.userData[openData.place].users[openData.userIndex]?.schedulesDates[openData.dayIndex]?.items ?? null;
//             const newSchedule = response.data.item;
//             if (newSchedule) {
//               if (schedules) {
//                 schedules[openData.scheduleIndex] = { ...schedules[openData.scheduleIndex], updated: true, _id: newSchedule._id, startTime: newSchedule.startTime, endTime: newSchedule.endTime, endBuffer: newSchedule.endBuffer, startBuffer: newSchedule.startBuffer, user: newSchedule.user, published: false };
//               }
//             } else {
//               if (schedules) {
//                 delete schedules[openData.scheduleIndex];
//               }
//             }
            
//             if(loadedDataTemp?.data?.publishCount){
//               loadedDataTemp.data.publishCount += 1;
//             }else{
//               loadedDataTemp.data.publishCount = 1;
//             }
//           } else {
//             const loadedDataTemp = loadedData;
//             const schedules = loadedDataTemp.data.userData[openData.place].requiredShifts[openData.dayIndex]?.items ?? null;
//             const newSchedule = response.data.item;
//             if (newSchedule) {
//               if (schedules) {
//                 schedules[openData.scheduleIndex] = { ...schedules[openData.scheduleIndex], updated: true, _id: newSchedule._id, startTime: newSchedule.startTime, endTime: newSchedule.endTime, place: newSchedule.place, requiredType: newSchedule.requiredType, serviceCount: newSchedule.serviceCount, timeSettings: newSchedule.timeSettings };
//               }
//             } else {
//               if (schedules) {
//                 delete schedules[openData.scheduleIndex];
//               }
//             }
//             if(loadedDataTemp?.data?.publishCount){
//               loadedDataTemp.data.publishCount += 1;
//             }else{
//               loadedDataTemp.data.publishCount = 1;
//             }
//           }
//           if (data.deleteAll) {
//             refreshView(0);
//           }
//           // refreshView(currentIndex);
//           setModifySchedule(false);
//         } else if (response.status === 404) {
//           setMessage({ type: 1, content: t(response.data), proceed: "Okay" });
//         } else {
//           setMessage({ type: 1, content: t(response.data), proceed: "Okay" });
//         }
//         setLoaderBox(false);
//       })
//       .catch((error) => {
//         alert(error);
//         setLoaderBox(false);
//       });
//   };
//   useEffect(() => {
//     setLoaderBox(users.isLoading);
//     if (currentIndex === 0 && users.data?.userData) {
//       setCount(users.data.userData.length);
//     }
//   }, [users, currentIndex, setLoaderBox]);

//   useEffect(() => {
//     if (initialized) {
//       dispatch(addPageObject(currentApi, currentIndex, 0, filterView));
//     }
//   }, [initialized, currentApi, currentIndex, dispatch, filterView]);
//   const refreshView = (currentIndex) => {
//     try {
//       dispatch(addPageObject(currentApi, currentIndex, 0, filterView));
//     } catch {}
//   };
//   // const [isCreating, setIsCreating] = useState(false);

//   const handleDrop = async (dropType = "copy", isUpcoming, type, place, event, date, userIndex, dayIndex, user, placeId) => {
//     stopDrag();

//     if(selectedReqShift.length > 0 || selectedElements.length>0 || selectedOpenShift.length>0) {
//       // Retrieve the array of selected schedules
//       const selectedSchedules = JSON.parse(event.dataTransfer.getData("text/plain"));
//       if (!isUpcoming) {
//     setMessage({ content: "Not able to drop here!" });
//     return;
//       }

//       let currentDayIndex = dayIndex; // Start with the initial day index
//       let currentDate = new Date(date); // Start with the provided date
//       let deleteDayIndex = new Date();

//       const loadedDataTemp = { ...loadedData }; // Copy loadedData

//       // Helper function to format date as "YYYY-MM-DD"
//       const formatDate = (date) => {
//       const year = date.getFullYear();
//       const month = String(date.getMonth() + 1).padStart(2, '0');
//       const day = String(date.getDate()).padStart(2, '0');
//       return `${year}-${month}-${day}`;
//     };

//     // Set the currentDayIndex to the formatted date initially
//     currentDayIndex = formatDate(currentDate);
//     if(selectedSchedules.dayIndex){
//       deleteDayIndex = new Date(selectedSchedules.dayIndex);
//     }

//     deleteDayIndex=formatDate(deleteDayIndex);
//     // Iterate over selected schedules to apply the drop logic sequentially across days
//     for (let i = 0; i < selectedSchedules.schedule.length; i++) {
//       const schedule = selectedSchedules.schedule[i];
//       const originalStartTime = new Date(schedule.startTime);
//       const originalEndTime = new Date(schedule.endTime);
//       setLoaderBox(true);
//       // Adjust the start and end times to match the new day
//       const updatedStartTime = new Date(currentDate);
//       updatedStartTime.setHours(originalStartTime.getHours());
//       updatedStartTime.setMinutes(originalStartTime.getMinutes());
//       updatedStartTime.setSeconds(originalStartTime.getSeconds());

//       const updatedEndTime = new Date(currentDate);
//       updatedEndTime.setHours(originalEndTime.getHours());
//       updatedEndTime.setMinutes(originalEndTime.getMinutes());
//       updatedEndTime.setSeconds(originalEndTime.getSeconds());

//       // Check if the current schedule matches your conditions
//       if (type === selectedSchedules.type && isUpcoming && currentDate.toISOString().split('T')[0] !== selectedSchedules.entry.date) {

//         if (selectedSchedules.type === "requiredShift") {
//         const updatedSchedule = {
//           place: placeId,
//           _id: schedule._id,
//           startTime: updatedStartTime.toISOString(),
//           endTime: updatedEndTime.toISOString(),
//           dropType,
//         };

//         try {
//           // Await the API call so it processes before continuing the loop
//           const response = await postData(updatedSchedule, "shift/copyRequiredShift");
//           const shifts = loadedDataTemp.data.userData[place].requiredShifts[currentDayIndex]?.items ?? null;
          
//           if (response.status === 200) {
//             const newSchedule = response.data.newSchedule;
//             if(loadedDataTemp?.data?.publishCount){
//               loadedDataTemp.data.publishCount += 1;
//             }else{
//               loadedDataTemp.data.publishCount = 1;
//             }
//             if (shifts) {
//               shifts.push({
//                 ...schedule,
//                 _id: newSchedule._id,
//                 startTime: newSchedule.startTime,
//                 endTime: newSchedule.endTime,
//                 place: newSchedule.place,
//                 published: false
//               });
//             } else {
//               loadedDataTemp.data.userData[place].requiredShifts[currentDayIndex] = {
//                 items: [{
//                   ...schedule,
//                   _id: newSchedule._id,
//                   startTime: newSchedule.startTime,
//                   endTime: newSchedule.endTime,
//                   place: newSchedule.place,
//                   published: false
//                 }]
//               };
//             }
//           } else {
//             setMessage({ type: 1, content: t(response.data), proceed: "Okay" });
//           }
//         } catch (error) {
//           alert(error);
//         }
//       }
//       else if(selectedSchedules.type === "schedule" ){
//         const updatedSchedule = {
//           user,
//           _id: schedule._id,
//           startTime: updatedStartTime.toISOString(),
//           endTime: updatedEndTime.toISOString(),
//           dropType,
//         };

//         try {
//           const response = await postData(updatedSchedule, "shift/copySchedule");
//           const schedules = loadedDataTemp.data.userData[place].users[userIndex].schedulesDates[currentDayIndex]?.items ?? null;
//           if (response.status === 200) {
//             const newSchedule = response.data.newSchedule;
//             if (dropType === "copy" || dropType === "expand") {
//               if (schedules) {
//                 schedules.push({ ...schedule, updated: true, _id: newSchedule._id, startTime: newSchedule.startTime, endTime: newSchedule.endTime, endBuffer: newSchedule.endBuffer, startBuffer: newSchedule.startBuffer, user: newSchedule.user, published: false });
//               } else {
//                 loadedDataTemp.data.userData[place].users[userIndex].schedulesDates[currentDayIndex] = { items: [{ ...schedule, updated: true, _id: newSchedule._id, startTime: newSchedule.startTime, endTime: newSchedule.endTime, endBuffer: newSchedule.endBuffer, startBuffer: newSchedule.startBuffer, user: newSchedule.user, published: false }] };
//               }
//             } else {
//               if (schedules) {
//                 schedules.push({ ...schedule, updated: true, _id: newSchedule._id, startTime: newSchedule.startTime, endTime: newSchedule.endTime, endBuffer: newSchedule.endBuffer, startBuffer: newSchedule.startBuffer, user: newSchedule.user, published: false });
//               } else {
//                 loadedDataTemp.data.userData[place].users[userIndex].schedulesDates[currentDayIndex] = { items: [{ ...schedule, updated: true, _id: newSchedule._id, startTime: newSchedule.startTime, endTime: newSchedule.endTime, endBuffer: newSchedule.endBuffer, startBuffer: newSchedule.startBuffer, user: newSchedule.user , published: false}] };
//               }
//               delete loadedDataTemp.data.userData[place].users[selectedSchedules.userIndex].schedulesDates[deleteDayIndex].items[selectedSchedules.scheduleIndex];
//             }
//             if(loadedDataTemp?.data?.publishCount){
//               loadedDataTemp.data.publishCount += 1;
//             }else{
//               loadedDataTemp.data.publishCount = 1;
//             }
//           } else if (response.status === 404) {
//             setMessage({ type: 1, content: t(response.data), proceed: "Okay" });
//           } else {
//             setMessage({ type: 1, content: t(response.data), proceed: "Okay" });
//           }
//         } catch (error) {
//           alert(error);
//         }
//       }
//       else if (selectedSchedules.type === "openServices") {

//         const updatedSchedule = {
//           place: placeId,
//           _id: schedule._id,
//           startTime: updatedStartTime.toISOString(),
//           endTime: updatedEndTime.toISOString(),
//           dropType,
//         };
//         try {
//           const response = await postData(updatedSchedule, "shift/copyOpenShift");
//           const shifts = loadedDataTemp.data.userData[place].openService[currentDayIndex]?.items ?? null;
//           if (response.status === 200) {
//             const newSchedule = response.data.newSchedule;
//             if (shifts) {
//               shifts.push({ ...schedule, updated: true, _id: newSchedule._id, startTime: newSchedule.startTime, endTime: newSchedule.endTime, endBuffer: newSchedule.endBuffer, startBuffer: newSchedule.startBuffer, place: newSchedule.place, published: false });
//             } else {
//               loadedDataTemp.data.userData[place].openService[currentDayIndex] = { items: [{ ...schedule,updated: true, _id: newSchedule._id, startTime: newSchedule.startTime, endTime: newSchedule.endTime, endBuffer: newSchedule.endBuffer, startBuffer: newSchedule.startBuffer, place: newSchedule.place , published: false}] };
//             }
//           } else if (response.status === 404) {
//             setMessage({ type: 1, content: t(response.data), proceed: "Okay" });
//           } else {
//             setMessage({ type: 1, content: t(response.data), proceed: "Okay" });
//           }
//         } catch (error) {
//           alert(error);
//         }
//         if (workTimeLog) setLoaderBox(false);
//         setLoadedData(loadedDataTemp);
//       }
      
//     }
//     else if (type === "schedule" && selectedSchedules.type === "requiredShift") {
//       const updatedSchedule = {
//         user,
//         _id: schedule._id,
//         startTime: updatedStartTime.toISOString(),
//         endTime: updatedEndTime.toISOString(),
//         dropType,
//       };

//       try {
//         const response = await postData(updatedSchedule, "shift/copyRequiredToSchedule");
//         const schedules = loadedDataTemp.data.userData[place].users[userIndex].schedulesDates[currentDayIndex]?.items ?? null;
//         // console.log("schedules", schedules);
//         if (response.status === 200) {
//           const newSchedule = response.data.newSchedule;
//           if(loadedDataTemp?.data?.publishCount){
//               loadedDataTemp.data.publishCount += 1;
//             }else{
//               loadedDataTemp.data.publishCount = 1;
//             }
//           // console.log("new", { items: [{ ...newSchedule, updated: true, shiftDetails: schedule.schedule.shiftDetails, _id: newSchedule._id, startTime: newSchedule.startTime, endTime: newSchedule.endTime, endBuffer: newSchedule.endBuffer, startBuffer: newSchedule.startBuffer, user: newSchedule.user }] });
//           if (schedules) {
//             schedules.push({ ...newSchedule, updated: true, shiftDetails: schedule.shiftDetails, user: newSchedule.user, published: false });
//           } else {
//             loadedDataTemp.data.userData[place].users[userIndex].schedulesDates[currentDayIndex] = { items: [{ ...newSchedule, updated: true, shiftDetails: schedule.shiftDetails, _id: newSchedule._id, startTime: newSchedule.startTime, endTime: newSchedule.endTime, endBuffer: newSchedule.endBuffer, startBuffer: newSchedule.startBuffer, user: newSchedule.user, published: false }] };
//           }
//           // if (schedules) {
//           //   schedules.push({ ...schedule.schedule, updated: true, _id: newSchedule._id, startTime: newSchedule.startTime, endTime: newSchedule.endTime, endBuffer: newSchedule.endBuffer, startBuffer: newSchedule.startBuffer, user: newSchedule.user });
//           // } else {
//           //   loadedDataTemp.data.userData[place].users[userIndex].schedulesDates[dayIndex] = { items: [{ ...schedule.schedule, updated: true, _id: newSchedule._id, startTime: newSchedule.startTime, endTime: newSchedule.endTime, endBuffer: newSchedule.endBuffer, startBuffer: newSchedule.startBuffer, user: newSchedule.user }] };
//           // }
//         } else if (response.status === 404) {
//           setMessage({ type: 1, content: t(response.data), proceed: "Okay" });
//         } else {
//           setMessage({ type: 1, content: t(response.data), proceed: "Okay" });
//         }
//         setLoadedData(loadedDataTemp);
//       } catch (error) {
//         alert(error);
//       }
//     }

//     if (i + 1 < selectedSchedules.schedule.length) {
//       const nextSchedule = selectedSchedules.schedule[i + 1];
//       const nextStartTime = new Date(nextSchedule.startTime);
//       const timeDifference = nextStartTime - originalStartTime; // time difference in milliseconds

//       // Update the current date based on the difference
//       currentDate.setTime(currentDate.getTime() + timeDifference);

//       // Update the currentDayIndex and deleteDayIndex
//       currentDayIndex = formatDate(currentDate); // Update the currentDayIndex with the new formatted date
      
//       let dateVal = new Date(deleteDayIndex);
//       dateVal.setTime(dateVal.getTime() + timeDifference);
//       deleteDayIndex = formatDate(dateVal);
//     }
//     }

//     setLoaderBox(false);
//     setLoadedData(loadedDataTemp);

//     }
//     else{
//     const schedule = JSON.parse(event.dataTransfer.getData("text/plain"));
//     const originalStartTime = new Date(schedule.schedule.startTime);
//     const originalEndTime = new Date(schedule.schedule.endTime);
//     const loadedDataTemp = { ...loadedData }; // Create a copy of loadedData
//     if (!isUpcoming) {
//       setMessage({ content: "Not able to drop here!" });
//       return;
//     }
//     if (type === schedule.type && isUpcoming && date !== schedule.entry.date) {
//       if (schedule.type === "schedule") {
//         setLoaderBox(true);

//         const updatedStartTime = new Date(date);
//         updatedStartTime.setHours(originalStartTime.getHours());
//         updatedStartTime.setMinutes(originalStartTime.getMinutes());
//         updatedStartTime.setSeconds(originalStartTime.getSeconds());

//         const updatedEndTime = new Date(date);
//         updatedEndTime.setHours(originalEndTime.getHours());
//         updatedEndTime.setMinutes(originalEndTime.getMinutes());
//         updatedEndTime.setSeconds(originalEndTime.getSeconds());

//         const updatedSchedule = {
//           user,
//           _id: schedule.schedule._id,
//           startTime: updatedStartTime.toISOString(),
//           endTime: updatedEndTime.toISOString(),
//           dropType,
//         };

//         try {
//           const response = await postData(updatedSchedule, "shift/copySchedule");
//           const schedules = loadedDataTemp.data.userData[place].users[userIndex].schedulesDates[dayIndex]?.items ?? null;
//           if (response.status === 200) {
//             const newSchedule = response.data.newSchedule;
//             if(loadedDataTemp?.data?.publishCount){
//               loadedDataTemp.data.publishCount += 1;
//             }else{
//               loadedDataTemp.data.publishCount = 1;
//             }
//             if (dropType === "copy" || dropType === "expand") {
//               if (schedules) {
//                 schedules.push({ ...schedule.schedule, updated: true, _id: newSchedule._id, startTime: newSchedule.startTime, endTime: newSchedule.endTime, endBuffer: newSchedule.endBuffer, startBuffer: newSchedule.startBuffer, user: newSchedule.user, published: false });
//               } else {
//                 loadedDataTemp.data.userData[place].users[userIndex].schedulesDates[dayIndex] = { items: [{ ...schedule.schedule, updated: true, _id: newSchedule._id, startTime: newSchedule.startTime, endTime: newSchedule.endTime, endBuffer: newSchedule.endBuffer, startBuffer: newSchedule.startBuffer, user: newSchedule.user, published: false }] };
//               }
//             } else {
//               if (schedules) {
//                 schedules.push({ ...schedule.schedule, updated: true, _id: newSchedule._id, startTime: newSchedule.startTime, endTime: newSchedule.endTime, endBuffer: newSchedule.endBuffer, startBuffer: newSchedule.startBuffer, user: newSchedule.user, published: false });
//               } else {
//                 loadedDataTemp.data.userData[place].users[userIndex].schedulesDates[dayIndex] = { items: [{ ...schedule.schedule, updated: true, _id: newSchedule._id, startTime: newSchedule.startTime, endTime: newSchedule.endTime, endBuffer: newSchedule.endBuffer, startBuffer: newSchedule.startBuffer, user: newSchedule.user, published: false }] };
//               }
//               delete loadedDataTemp.data.userData[place].users[schedule.userIndex].schedulesDates[schedule.dayIndex].items[schedule.scheduleIndex];
//             }
//           } else if (response.status === 404) {
//             setMessage({ type: 1, content: t(response.data), proceed: "Okay" });
//           } else {
//             setMessage({ type: 1, content: t(response.data), proceed: "Okay" });
//           }
//         } catch (error) {
//           alert(error);
//         }

//         setLoaderBox(false);
//         setLoadedData(loadedDataTemp);
//       } else if (schedule.type === "requiredShift") {
//         const loadedDataTemp = { ...loadedData }; // Create a copy of loadedData

//         setLoaderBox(true);

//         const updatedStartTime = new Date(date);
//         updatedStartTime.setHours(originalStartTime.getHours());
//         updatedStartTime.setMinutes(originalStartTime.getMinutes());
//         updatedStartTime.setSeconds(originalStartTime.getSeconds());

//         const updatedEndTime = new Date(date);
//         updatedEndTime.setHours(originalEndTime.getHours());
//         updatedEndTime.setMinutes(originalEndTime.getMinutes());
//         updatedEndTime.setSeconds(originalEndTime.getSeconds());

//         const updatedSchedule = {
//           place: placeId,
//           _id: schedule.schedule._id,
//           startTime: updatedStartTime.toISOString(),
//           endTime: updatedEndTime.toISOString(),
//           dropType,
//         };
//         try {
//           const response = await postData(updatedSchedule, "shift/copyRequiredShift");
//           const shifts = loadedDataTemp.data.userData[place].requiredShifts[dayIndex]?.items ?? null;
//           if (response.status === 200) {
//             const newSchedule = response.data.newSchedule;
//             if(loadedDataTemp?.data?.publishCount){
//               loadedDataTemp.data.publishCount += 1;
//             }else{
//               loadedDataTemp.data.publishCount = 1;
//             }
//             if (shifts) {
//               shifts.push({ ...schedule.schedule, _id: newSchedule._id, startTime: newSchedule.startTime, endTime: newSchedule.endTime, place: newSchedule.place, published: false });
//             } else {
//               loadedDataTemp.data.userData[place].requiredShifts[dayIndex] = { items: [{ ...schedule.schedule, _id: newSchedule._id, startTime: newSchedule.startTime, endTime: newSchedule.endTime, place: newSchedule.place, published: false }] };
//             }
//           } else if (response.status === 404) {
//             setMessage({ type: 1, content: t(response.data), proceed: "Okay" });
//           } else {
//             setMessage({ type: 1, content: t(response.data), proceed: "Okay" });
//           }
//         } catch (error) {
//           alert(error);
//         }
//         if (workTimeLog) setLoaderBox(false);
//         setLoadedData(loadedDataTemp);
//       } else if (schedule.type === "openServices") {
//         const loadedDataTemp = { ...loadedData }; // Create a copy of loadedData

//         setLoaderBox(true);

//         const updatedStartTime = new Date(date);
//         updatedStartTime.setHours(originalStartTime.getHours());
//         updatedStartTime.setMinutes(originalStartTime.getMinutes());
//         updatedStartTime.setSeconds(originalStartTime.getSeconds());

//         const updatedEndTime = new Date(date);
//         updatedEndTime.setHours(originalEndTime.getHours());
//         updatedEndTime.setMinutes(originalEndTime.getMinutes());
//         updatedEndTime.setSeconds(originalEndTime.getSeconds());

//         const updatedSchedule = {
//           place: placeId,
//           _id: schedule.schedule._id,
//           startTime: updatedStartTime.toISOString(),
//           endTime: updatedEndTime.toISOString(),
//           dropType,
//         };
//         try {
//           const response = await postData(updatedSchedule, "shift/copyOpenShift");
//           const shifts = loadedDataTemp.data.userData[place].openService[dayIndex]?.items ?? null;
//           if (response.status === 200) {
//             const newSchedule = response.data.newSchedule;
//             if (shifts) {
//               shifts.push({ ...schedule.schedule, updated: true, _id: newSchedule._id, startTime: newSchedule.startTime, endTime: newSchedule.endTime, endBuffer: newSchedule.endBuffer, startBuffer: newSchedule.startBuffer, place: newSchedule.place, published: false });
//             } else {
//               loadedDataTemp.data.userData[place].openService[dayIndex] = { items: [{ ...schedule.schedule,updated: true, _id: newSchedule._id, startTime: newSchedule.startTime, endTime: newSchedule.endTime, endBuffer: newSchedule.endBuffer, startBuffer: newSchedule.startBuffer, place: newSchedule.place, published: false }] };
//             }
//           } else if (response.status === 404) {
//             setMessage({ type: 1, content: t(response.data), proceed: "Okay" });
//           } else {
//             setMessage({ type: 1, content: t(response.data), proceed: "Okay" });
//           }
//         } catch (error) {
//           alert(error);
//         }
//         if (workTimeLog) setLoaderBox(false);
//         setLoadedData(loadedDataTemp);
//       }
//     } else if (type === "schedule" && schedule.type === "requiredShift") {
//       const loadedDataTemp = { ...loadedData }; // Create a copy of loadedData

//       setLoaderBox(true);
//       const updatedStartTime = new Date(date);
//       updatedStartTime.setHours(originalStartTime.getHours());
//       updatedStartTime.setMinutes(originalStartTime.getMinutes());
//       updatedStartTime.setSeconds(originalStartTime.getSeconds());

//       const updatedEndTime = new Date(date);
//       updatedEndTime.setHours(originalEndTime.getHours());
//       updatedEndTime.setMinutes(originalEndTime.getMinutes());
//       updatedEndTime.setSeconds(originalEndTime.getSeconds());

//       const updatedSchedule = {
//         user,
//         _id: schedule.schedule._id,
//         startTime: updatedStartTime.toISOString(),
//         endTime: updatedEndTime.toISOString(),
//         dropType,
//       };

//       try {
//         const response = await postData(updatedSchedule, "shift/copyRequiredToSchedule");
//         const schedules = loadedDataTemp.data.userData[place].users[userIndex].schedulesDates[dayIndex]?.items ?? null;
//         // console.log("schedules", schedules);
//         if (response.status === 200) {
//           const newSchedule = response.data.newSchedule;
//           if(loadedDataTemp?.data?.publishCount){
//               loadedDataTemp.data.publishCount += 1;
//             }else{
//               loadedDataTemp.data.publishCount = 1;
//             }
//           // console.log("new", { items: [{ ...newSchedule, updated: true, shiftDetails: schedule.schedule.shiftDetails, _id: newSchedule._id, startTime: newSchedule.startTime, endTime: newSchedule.endTime, endBuffer: newSchedule.endBuffer, startBuffer: newSchedule.startBuffer, user: newSchedule.user }] });
//           if (schedules) {
//             schedules.push({ ...newSchedule, updated: true, shiftDetails: schedule.schedule.shiftDetails, user: newSchedule.user, published: false });
//           } else {
//             loadedDataTemp.data.userData[place].users[userIndex].schedulesDates[dayIndex] = { items: [{ ...newSchedule, updated: true, shiftDetails: schedule.schedule.shiftDetails, _id: newSchedule._id, startTime: newSchedule.startTime, endTime: newSchedule.endTime, endBuffer: newSchedule.endBuffer, startBuffer: newSchedule.startBuffer, user: newSchedule.user, published: false }] };
//           }
//           // if (schedules) {
//           //   schedules.push({ ...schedule.schedule, updated: true, _id: newSchedule._id, startTime: newSchedule.startTime, endTime: newSchedule.endTime, endBuffer: newSchedule.endBuffer, startBuffer: newSchedule.startBuffer, user: newSchedule.user });
//           // } else {
//           //   loadedDataTemp.data.userData[place].users[userIndex].schedulesDates[dayIndex] = { items: [{ ...schedule.schedule, updated: true, _id: newSchedule._id, startTime: newSchedule.startTime, endTime: newSchedule.endTime, endBuffer: newSchedule.endBuffer, startBuffer: newSchedule.startBuffer, user: newSchedule.user }] };
//           // }
//         } else if (response.status === 404) {
//           setMessage({ type: 1, content: t(response.data), proceed: "Okay" });
//         } else {
//           setMessage({ type: 1, content: t(response.data), proceed: "Okay" });
//         }
//         setLoadedData(loadedDataTemp);
//       } catch (error) {
//         alert(error);
//       }

//       setLoaderBox(false);
//       setLoadedData(loadedDataTemp);
//     } else {
//     }

//     if (dropType === "expand") {
//       setLoaderBox(true);
//       const updatedStartTime = new Date(date);
//       const copyStartDate = moment(originalStartTime);
//       const copyEndDate = moment(updatedStartTime);
//       const numDaysBetween = copyEndDate.diff(copyStartDate, "days");

//       // hwo to check how many dates between startDate and endDate
//       if (originalStartTime < updatedStartTime && numDaysBetween > 0 && user === schedule.schedule.user) {
//         const updatedStartTime = new Date(date);
//         updatedStartTime.setHours(originalStartTime.getHours(), originalStartTime.getMinutes(), originalStartTime.getSeconds());

//         const updatedEndTime = new Date(date);
//         updatedEndTime.setHours(originalEndTime.getHours(), originalEndTime.getMinutes(), originalEndTime.getSeconds());

//         const updatedSchedule = {
//           user,
//           _id: schedule.schedule._id,
//           shiftScheduleId: schedule.schedule.shiftSchedule,
//           startTime: updatedStartTime.toISOString(),
//           endTime: updatedEndTime.toISOString(),
//           startDate: copyStartDate.add(1, "days").startOf("day").add(7, "hours").toISOString(),
//           endDate: copyEndDate.add(-1, "days").startOf("day").add(15, "hours").toISOString(),
//         };

//         try {
//           // const loadedDataTemp = { ...loadedData }; // Create a copy of loadedData
//           const response = await postData(updatedSchedule, "shift/copyScheduleBetween");
//           try {
//             if (response.status === 200) {
//               response.data?.savedItems?.forEach((newSchedule) => {
//                 const newdayIndex = moment(new Date(newSchedule.startTime)).format("YYYY-MM-DD");
//                 const schedules = loadedDataTemp.data.userData[place].users[userIndex].schedulesDates[newdayIndex]?.items ?? null;
//                 if(loadedDataTemp?.data?.publishCount){
//               loadedDataTemp.data.publishCount += 1;
//             }else{
//               loadedDataTemp.data.publishCount = 1;
//             }
//                 if (schedules) {
//                   schedules.push({ ...schedule.schedule, updated: true, _id: newSchedule._id, startTime: newSchedule.startTime, endTime: newSchedule.endTime, endBuffer: newSchedule.endBuffer, startBuffer: newSchedule.startBuffer, user: newSchedule.user, published: false });
//                 } else {
//                   loadedDataTemp.data.userData[place].users[userIndex].schedulesDates[newdayIndex] = { items: [{ ...schedule.schedule, updated: true, _id: newSchedule._id, startTime: newSchedule.startTime, endTime: newSchedule.endTime, endBuffer: newSchedule.endBuffer, startBuffer: newSchedule.startBuffer, user: newSchedule.user, published: false }] };
//                 }
//               });
//             }
//           } catch (error) {
//             setLoaderBox(false);
//           }
//           setLoaderBox(false);
//           setLoadedData(loadedDataTemp);
//         } catch {}
//       }
//     }
//   }
//   setLoaderBox(false);
//   };
  
  

// const ActionBox = ({ onEdit, onDelete, onAdd, onSelect, isSelected = false, color, addDate, type = "" }) => {
//   // const [isDragging, setIsDragging] = useState(false);

//   // useEffect(() => {
//   //   console.log("object",dragStatus);
//   //   if (dragStatus) {
//   //     setIsDragging(true);  // Start tracking the drag
//   //   } else {
//   //     // Delay to ensure button actions are processed
//   //     const timer = setTimeout(() => setIsDragging(false), 50); // Allow time to process actions
//   //     return () => clearTimeout(timer);  // Clean up timer
//   //   }
//   // }, [dragStatus]);

//   // const handleAction = (action) => {
//   //   // Only trigger the action if not dragging
//   //   console.log(isDragging);
//   //   if (!isDragging) {
//   //     action();
//   //   }
//   // };

//   return (
//     <HoverActions className="action" color={color}>
//       <button
//         onMouseUp={onEdit} // Handle edit action
//         // onMouseUp={() => handleAction(onEdit)} // Handle edit action
//       >
//         <GetIcon icon={"edit"} />
//       </button>
//       <button
//         onMouseUp={onDelete} // Handle delete action
//         // onMouseUp={() => handleAction(onDelete)} // Handle delete action
//       >
//         <GetIcon icon={"delete"} />
//       </button>
//       {(type === "requiredShift" && onAdd) ? (
//         <button
//           onMouseUp={onAdd} // Handle add action
//           // onMouseUp={() => handleAction(onAdd)} // Handle add action
//         >
//           <GetIcon icon={"add"} />
//         </button>
//       ) : (
//         onAdd &&
//         addDate >= new Date() && (
//           <button
//             onMouseUp={onAdd} // Handle add action if the date is valid
//             // onMouseUp={() => handleAction(onAdd)} // Handle add action if the date is valid
//           >
//             <GetIcon icon={"add"} />
//           </button>
//         )
//       )}
//     </HoverActions>
//   );
// };

  
//   const DropActionBox = ({ isUpcoming, type, place, date, userIndex, dayIndex, user, placeId, color, addDate }) => {
//     return isUpcoming ? (
//       <HoverActions
//         onMouseEnter={() => {
//           setDragOver("");
//         }}
//         className="draghover"
//         color={color}
//       >
//         {"schedule" === dragData.type && (
//           <button
//             onDrop={(event) => {
//               handleDrop("move", isUpcoming, type, place, event, date, userIndex, dayIndex, user, placeId);
//               setDragOver("");
//             }}
//             onDragOver={(e) => e.preventDefault()}
//           >
//             <GetIcon icon={"move"} />
//           </button>
//         )}
//         <button
//           onDrop={(event) => {
//             handleDrop("copy", isUpcoming, type, place, event, date, userIndex, dayIndex, user, placeId);
//             setDragOver("");
//           }}
//           onDragOver={(e) => e.preventDefault()}
//         >
//           <GetIcon icon={"copy"} />
//         </button>
//         {addDate && addDate >= new Date() && user === dragData.user && (
//           <button
//             onDrop={(event) => {
//               handleDrop("expand", isUpcoming, type, place, event, date, userIndex, dayIndex, user, placeId);
//               setDragOver("");
//             }}
//             onDragOver={(e) => e.preventDefault()}
//           >
//             <GetIcon icon={"expand"} />
//           </button>
//         )}
//       </HoverActions>
//     ) : (
//       <HoverActions
//         onMouseEnter={() => {
//           setDragOver("");
//         }}
//         className="draghover"
//       ></HoverActions>
//     );
//   };
//   const [dragOver, setDragOver] = useState("");
//   const [dragData, setDragData] = useState({});
//   // const countedShifts = {};
//   function countShiftsByType(value, entry, shift, type="requiredShift") {
//     try {
//       let value1 = 0;
//       value.users.forEach((user) => {
//         if(type==="requiredShift"){
//           const userDates = user.schedulesDates[entry.date]?.items ?? [];

//           userDates?.forEach((s) => {
//             if (moment(new Date(s.startTime)).format("YYYY-MM-DD") !== entry.date) {
//               return s;
//             }
//             // if ((countedShifts[s._id] ?? false) === true) {
//             //   return s;
//             // }
//             // if (shift.serviceCount === value1) {
//             //   return s;
//             // }
//             if (shift.shiftTemplate !== s.shiftTemplate) {
//               return s;
//             }
//             switch (shift.timeSettings) {
//               case "any":
//                 if (moment(new Date(s.startTime)).format("YYYY-MM-DD") === entry.date) {
//                   value1 += 1;
//                   // countedShifts[s._id] = true;
//                 }
//                 break;
//               case "outside":
//                 if (moment(new Date(s.endTime)).isAfter(moment(new Date(shift.endTime))) && moment(new Date(s.endTime)).isBefore(moment(new Date(shift.endTime)))) {
//                   value1 += 1;
//                   // countedShifts[s._id] = true;
//                 }
//                 break;
//               case "starting":
//                 if (moment(new Date(s.startTime)).isSame(moment(new Date(shift.startTime)))) {
//                   value1 += 1;
//                   // countedShifts[s._id] = true;
//                 }
//                 break;
//               case "ending":
//                 if (moment(new Date(s.endTime)).isSame(moment(new Date(shift.endTime)))) {
//                   value1 += 1;
//                   // countedShifts[s._id] = true;
//                 }
//                 break;
//               case "exact":
//                 if (moment(new Date(s.startTime)).isSame(moment(new Date(shift.startTime))) && moment(new Date(s.endTime)).isSame(moment(new Date(shift.endTime)))) {
//                   value1 += 1;
//                   // countedShifts[s._id] = true;
//                 }
//                 break;
//               default:
//                 break;
//             }
//             return s;
//           });
//         } else if(type==="openService"){
//           const userDates = user.openShifts[entry.date]?.items ?? [];
//           userDates?.forEach((s) => {
//             if (moment(new Date(s.startTime)).format("YYYY-MM-DD") !== entry.date) {
//               return s;
//             }
//             // if ((countedShifts[s._id] ?? false) === true) {
//             //   return s;
//             // }
//             // if (shift.serviceCount === value1) {
//             //   return s;
//             // }
//             if (shift.shiftTemplate !== s.shiftTemplate) {
//               return s;
//             }
//             if(s?.userApplicationStatus?.status==="confirmed"){
//               value1 += 1;
//             }
//             return s;
//           });
//         }
//       });

//       return value1;
//     } catch (error) {
//       return 0; // Return a default value or handle the error case accordingly
//     }
//   }
//   ///drag select
//   const [selectedElements, setSelectedElements] = useState([]);
//   const [selectedKeys, setSelectedKeys] = useState({});
//   const [selectedReqShift, setSelectedReqShift] = useState([]);
//   const [selectedReqShiftKeys, setSelectedReqShiftKeys] = useState({});
//   const [selectedOpenShift, setSelectedOpenShift] = useState([]);
//   const [selectedOpenShiftKeys, setSelectedOpenShiftKeys] = useState({});
//   const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
//   const [dragEnd, setDragEnd] = useState({ x: 0, y: 0 });
//   const [dragStatus, setDragStatus] = useState(false); // Added dragStatus state
//   const [dragMoving, setDragMoving] = useState(false); // Added dragStatus state
//   function handleDragStart(event) {
//     if (!dragStatus) {
//       const { clientX, clientY } = event;
//       setDragStatus(true); // Update dragStatus when starting drag
//       setDragStart({ x: clientX, y: clientY });
//       setDragEnd({ x: clientX, y: clientY });
//       document.body.focus();
//     }
//   }
//   function handleDragMove(event) {
//     if (dragStatus) {
//       if (!dragStart.x) return;
//       setDragMoving(true);
//       const { clientX, clientY } = event;
//       setDragEnd({ x: clientX, y: clientY });
//     } else {
//       setDragStart({ x: 0, y: 0 });
//       setDragEnd({ x: 0, y: 0 });
//     }
//   }

//   function handleDragEnd() {
//     // Add a condition to check before running the main logic
//     if (!isConditionMet()) {
//       setSelectedElements([]);
//       setSelectedKeys({});
//       setSelectedReqShift([]);
//       setSelectedReqShiftKeys({});
//       setSelectedOpenShift([]);
//       setSelectedOpenShiftKeys({});
//       stopDrag();
//       return; // Stop execution if the condition is not met
//     }

//     const scheduleElements = document.querySelectorAll(".schedule");
//     const selectedKeysTemp = {};
//     let selected = Array.from(scheduleElements)
//       .map((element) => isElementInSelection(element))
//       .filter((value) => {
//         if (value !== null) {
//           selectedKeysTemp[value] = true;
//           return true;
//         } else {
//           return false;
//         }
//       });
//     setSelectedElements(selected);
//     setSelectedKeys(selectedKeysTemp);

//     const selectedReqShiftTemp = document.querySelectorAll(".required");
    
//     const selectedReqShiftKeysTemp = {};
//     selected = Array.from(selectedReqShiftTemp)
//       .map((element) => isElementInSelection(element))
//       .filter((value) => {
//         if (value !== null) {
//           selectedReqShiftKeysTemp[value] = true;
//           return true;
//         } else {
//           return false;
//         }
//       });
//     setSelectedReqShift(selected);
//     setSelectedReqShiftKeys(selectedReqShiftKeysTemp);

//     const selectedOpenShiftTemp = document.querySelectorAll(".openShift");
//     const selectedOpenShiftKeysTemp = {};
//     selected = Array.from(selectedOpenShiftTemp)
//       .map((element) => isElementInSelection(element))
//       .filter((value) => {
//         if (value !== null) {
//           selectedOpenShiftKeysTemp[value] = true;
//           return true;
//         } else {
//           return false;
//         }
//       });
//     setSelectedOpenShift(selected);
//     setSelectedOpenShiftKeys(selectedOpenShiftKeysTemp);

//     stopDrag();
//   }
//   const handleDragStartProject = (e, id, sequence, prev, next) => {
//     e.dataTransfer.effectAllowed = "move";
//     e.dataTransfer.setData("text/plain", id + "-" + sequence + prev + "-" + next);
//   };

//   const handleDragOverProject = (e) => {
//     e.preventDefault();
//     e.dataTransfer.dropEffect = "move";
//   };
//   const handleDropProject = async (e, id, sequence, prev, next) => {
//     e.preventDefault();
//     setLoaderBox(true);
//     // Retrieve the dragged data and split it
//     let dataValue = e.dataTransfer.getData("text/plain");
//     dataValue = dataValue.split("-");
//     const draggedRowId = parseInt(dataValue[0]);
//     // const oldSequence = parseFloat(dataValue[1]);
//     // const prev = parseFloat(dataValue[1]);
//     // const next = parseFloat(dataValue[2]);
//     const droppedRow = loadedData.data?.userData[id];

//     // Copy data to update it

//     const updatedRows = { ...loadedData };

//     const draggedSequence = droppedRow.sequence ?? 0;
//     const dropedSequence = droppedRow.sequence ?? 0 + 0.001;

//     updatedRows.data.userData[draggedRowId].sequence = draggedSequence;
//     updatedRows.data.userData[id].sequence = dropedSequence;

//     const [draggedRow] = updatedRows.data?.userData.splice(draggedRowId, 1);
//     updatedRows.data?.userData.splice(id, 0, draggedRow);

//     // Update the state with the modified data

//     setLoadedData(updatedRows);
//     setSelectedElements([]);
//     setSelectedKeys({});
//     setSelectedReqShift([]);
//     setSelectedReqShiftKeys({});
//     stopDrag();
//     setLoaderBox(false);
//     await putData({ sequence: draggedSequence }, `place/${draggedRow.placeId}`);
//     await putData({ sequence: dropedSequence + 0.001 }, `place/${droppedRow.placeId}`);
//   };
//   function isConditionMet() {
//     const minX = Math.min(dragStart.x, dragEnd.x);
//     const maxX = Math.max(dragStart.x, dragEnd.x);
//     const minY = Math.min(dragStart.y, dragEnd.y);
//     const maxY = Math.max(dragStart.y, dragEnd.y);

//     // Define your condition based on minX, maxX, minY, and maxY
//     const conditionMet = maxX - minX >= 50 || maxY - minY >= 50;

//     return conditionMet;
//   }
//   const stopDrag = () => {
//     setOverId(null);
//     setDragStatus(false); // Reset dragStatus when ending drag
//     setDragStart({ x: 0, y: 0 });
//     setDragEnd({ x: 0, y: 0 });
//   };
//   function isElementInSelection(element, minWidth = 50, minHeight = 50) {
//     const minX = Math.min(dragStart.x, dragEnd.x);
//     const maxX = Math.max(dragStart.x, dragEnd.x);
//     const minY = Math.min(dragStart.y, dragEnd.y);
//     const maxY = Math.max(dragStart.y, dragEnd.y);

//     const elementRect = element.getBoundingClientRect();

//     const elementMinX = elementRect.left;
//     const elementMaxX = elementRect.right;
//     const elementMinY = elementRect.top;
//     const elementMaxY = elementRect.bottom;

//     const width = elementMaxX - elementMinX;
//     const height = elementMaxY - elementMinY;

//     const status = (width >= minWidth || height >= minHeight) && elementMaxX >= minX && elementMinX <= maxX && elementMaxY >= minY && elementMinY <= maxY;

//     if (status) {
//       return element.value;
//     } else {
//       return null;
//     }
//   }
//   const selectedMenu = useSelector((state) => state.selectedMenu);
//   const [attributes] = useState([
//     {
//       type: "select",
//       placeholder: "show",
//       name: "show",
//       validation: "",
//       default: "",
//       label: "",
//       required: false,
//       filter: true,
//       view: false,
//       add: false,
//       update: false,
//       filterType: "select",
//       apiType: "JSON",
//       selectApi: [
//         { id: "1", value: `${t("firstName")} ${t("lastName")}` },
//         { id: "2", value: `${t("lastName")} ${t("firstName")}` },
//         { id: "3", value: `${t("firstName")}` },
//         { id: "4", value: `${t("lastName")}` },
//       ],
//     },
//   ]);


//   return (
//     <Container className="noshadow">
//       <RowContainer className="list">
//         <Title className="inner">
//           <GetIcon icon={selectedMenu.icon}></GetIcon>
//           {t(selectedMenu.label)}
//         </Title>
//         <ButtonPanel>
//           <FilterBox>
//             <Search theme={themeColors} placeholder="Search" value={searchValue} onChange={handleChange}></Search>

//             <Filter
//               theme={themeColors}
//               onClick={() => {
//                 refreshView(currentIndex);
//               }}
//             >
//               <GetIcon icon={"reload"} />
//             </Filter>
//           </FilterBox>
//             <Filters style={{ marginRight: "0.5rem" }}>
//             <SelectTab
//               selected={viewMode}
//               onChange={(item) => {
//                 setViewMode(item);
//                 filterChange(null,{ id: item }, "viewMode");
//               }}
//               tabs={[
//                 { id: "day", title: "dayView" },
//                 { id: "week", title: "weekView" },
//                 { id: "month", title: "monthView" },
//               ]}
//             ></SelectTab>
//           </Filters>
//           <Filters style={{ marginRight: 0 }}>
//             {attributes.map((item, index) => {
//               return item.type === "select" && (item.filter ?? true) === true && <FormInput customClass={"filter"} placeholder={item.placeholder} value={filterView[item.name]} key={`input` + index} id={item.name} {...item} onChange={filterChange} />;
//             })}
//           </Filters>
          
//           <Filters className="center">
//             <DateSelector dynamicClass="filter" label={"Select Date"} placeholder={"Select Date"} selected={viewMode} value={new Date().toISOString()} onChange={dateRangeChange} themeColors={themeColors}></DateSelector>
//           </Filters>


//           <ToggleSwitchContainer className="list">
//             <ToggleInput
//               type="checkbox"
//               checked={showWorked}
//               icon={"open-book"}
//               onChange={async (event) => {
//                 setShowWorked(event.target.checked);
//               }}
//             />
//             <ToggleSwitch checked={showWorked} disable={"gray"} enable={"green"}>
//               <GetIcon icon={"open-book"} />
//             </ToggleSwitch>
//           </ToggleSwitchContainer>
//         </ButtonPanel>
//         <ScrollContainerLayout>
//           <ScrollLayout onMouseDown={handleDragStart} onMouseMove={handleDragMove} onMouseUp={handleDragEnd}>
//             <Table>
//               {loadedData.data?.userData?.length > 0 ? (
//                 loadedData.data?.userData.map((value, palceIndex) => {
//                   // Perform operations on each key-value pair
//                   const collapse = openedPlace[`place-${value.placeId}`] ?? loadedData.data.userData[palceIndex].isShow;
//                   const prev = loadedData.data.userData[palceIndex - 1]?.sequence ?? 0;
//                   const next = loadedData.data.userData[palceIndex + 1]?.sequence ?? value.sequence;
//                   let result = [];
//                   result.push(
//                     <React.Fragment key={palceIndex}>
//                       {/* <div style={{width: '100px',height:'100px',backgroundColor:value.color}}></div> */}
//                       <thead>
//                         <Tr
//                           draggable={true}
//                           onDragStart={(e) => {
//                             handleDragStartProject(e, palceIndex, value.sequence, prev, next);
//                           }}
//                           onDragOver={(e) => {
//                             handleDragOverProject(e);
//                           }}
//                           onDragLeave={() => {
//                             // setIsDragOver(false);
//                           }}
//                           onDrop={(e) => handleDropProject(e, palceIndex, value.sequence, prev, next)}
//                           color={value.color}
//                           className={"project " + (palceIndex === 0 ? "" : "secondHead")}
//                         >
//                           <Th color={value.color} style={viewMode === "day" ? { width: "calc(10%)" } : {}} className="name">
//                             <Collapse
//                               className={collapse}
//                               onClick={() => {
//                                 // const loadedDataTemp = { ...loadedData };
//                                 setOpenedPlace({ ...openedPlace, [`place-${value.placeId}`]: !collapse });
//                               }}
//                             >
//                               {collapse ? <GetIcon icon={"down"}></GetIcon> : <GetIcon icon={"down"}></GetIcon>}
//                             </Collapse>
//                             <span>{value.title}</span>
//                             <div className="small">{`${value.users.filter((item) => new Date(item.contractEnd) > new Date() || item.contractEnd !== null).length}/${value.users.length} ${t("employees")}`}</div>
//                           </Th>
//                           {viewMode !== "day" && workTimeLog.map((entry) => <Th className="center" key={entry.date}>{`${t(entry.dayName)}, ${entry.day}`}</Th>)}
//                           {viewMode === "day" && (
//                             // colSpan={24}
//                             <Th  className="center day">
//                               <DayBox>
//                                 {dayTimeLog.map((entry) => (
//                                   <div key={entry}>{entry}</div>
//                                 ))}
//                               </DayBox>
//                             </Th>
//                           )}
//                         </Tr>
//                       </thead>
//                       {collapse && (
//                         <React.Fragment>
//                           <tbody>
//                             {value.users.map((item, index) => {
//                               const isActive = new Date(item.contractEnd) > new Date() || item.contractEnd === null;
//                               const scheduleCount = Object.keys(item.schedulesDates).length;
//                               let totalHours = 0;
//                               let plannedHours = 0;
//                               return isActive || (!isActive && scheduleCount > 0) ? (
//                                 <Tr key={`work-log-${index}`}>
//                                   <Td className="name"  color={value.color} key={index}>
//                                     {generateThumbnail(item.fullName, isActive)}
//                                     {item.fullName}
//                                   </Td>

//                                   {workTimeLog.map((entry) => {
//                                     const daySchedules = item.schedulesDates[entry.date]?.items ?? [];
//                                     const openShifts = item.openShifts[entry.date]?.items ?? [];
//                                     const absences = item.absences[entry.date]?.items ?? [];
//                                     const availability = item.availability[entry.date]?.items ?? [];
//                                     const workedHours = item.attendanceData[entry.date]?.items ?? [];
//                                     const isUpcoming = true; //new Date(entry.originalDate) > new Date();
//                                     let hasSchedule = false;
//                                     totalHours += workedHours.reduce((acc, current) => acc + current.workedHours, 0);
//                                     plannedHours += daySchedules.reduce((acc, current) => acc + current.duration, 0);
//                                     const isHoliday = loadedData.data?.holidays?.[entry.date] ?? false;
//                                     const isWorkDay = !(item.WorkDays[entry.dayNameId.toLowerCase()] ?? true);
//                                     return (
//                                       <Td
//                                         // colSpan={viewMode === "day" && 24}
//                                         // onDrop={(event) => handleDrop("copy", isUpcoming, "schedule", palceIndex, event, entry.date, index, entry.date, item._id)}
//                                         onDragOver={(e) => setDragOver(`${palceIndex}-${index}-${entry.date}`)}
//                                         key={entry.date}
//                                         className={(daySchedules?.length > 0 || absences.length > 0 ? "has" : "no") + (dragOver === palceIndex + "-" + index + "-" + entry.date ? " dragged" : "")}
//                                       >
//                                         {isHoliday && (
//                                           <Absence className="absence" color={"red "}>
//                                             {/* <span> {t("holiday")}</span> */}
//                                             <span> {loadedData.data?.holidays?.[entry.date] ?? t("weekend")}</span>
//                                           </Absence>
//                                         )}
//                                         {isWorkDay && (
//                                           <Absence className="weekend" color={"red "}>
//                                             {/* <span> {t("weekend")}</span> */}
//                                           </Absence>
//                                         )}
//                                         {/* Render Availability */}
//                                         {availability.sort((a, b) => moment(a.startTime).isBefore(moment(b.startTime)) ? -1 : 1).map((schedule, scheduleIndex) => {
//                                             hasSchedule = true;
//                                             return (
//                                               <div
//                                                 key={schedule._id}
//                                                 value={schedule._id}
//                                                 style={{
//                                                   backgroundColor: (schedule.availableType==="not-full-day" || schedule.availableType==="not-available-from" ) ?"#FF0000":"#9ee0bb",
//                                                   // margin: 0,
//                                                   fontSize:'12px',
//                                                   borderRadius:'8px',
//                                                   color:'#000000'
//                                                 }}
//                                                 >
//                                                 {schedule.availableType==="available-from" ? <span className="available-from">
//                                                   {`${timeFormat(schedule.startTime)} - ${timeFormat(schedule.endTime)} ${window.innerWidth > 768 ? schedule?.reason:""}`}
//                                                   </span>
//                                                   : <span className="available-from">
//                                                     {t(`type-${schedule.availableType}`)}
//                                                   </span>
//                                                 }
//                                               </div>
//                                             );
//                                           })}
//                                         <SchedulesBox className={viewMode}>
//                                           {viewMode === "day" && (
//                                             <DayBox className="days">
//                                               {dayTimeLog.map((entry) => (
//                                                 <div key={entry}></div>
//                                               ))}
//                                             </DayBox>
//                                           )}

                                          
                                          

                                          
//                                           {/* Render absences */}
//                                           {absences.map((absence, scheduleIndex) => {
//                                             hasSchedule = true;
//                                             return (
//                                               <Schedule 
//                                               // onClick={()=>{
//                                               //   setOpenData({ place: palceIndex, userIndex: index, dayIndex: entry.date, scheduleIndex });
//                                               //   editAbsence(entry, item, scheduleIndex, absence);
//                                               //       document.body.focus();
//                                               //       setDragStatus(false);
//                                               // }} 
//                                               value={absence._id} color={absence.LeaveType?.[0]?.color ?? "black"} key={absence._id} onMouseEnter={() => setOverId(absence.user + "-" + absence.leaveType)} onMouseLeave={() => setOverId("")} className={(new Date(entry.originalDate) >= new Date() || new Date(entry.originalDate).toDateString() === new Date().toDateString() ? "" : "expired") + (overid === absence.user + "-" + absence.shiftSchedule ? " active" : "") + " absence schedule " + (selectedElements[absence._id] ? " selected" : "") + " " + absence.approval}>
//                                                 <span className="leave">{absence.LeaveType?.[0]?.[selectedLanguage]}</span>
//                                                 <span className="leave">{t(absence.approval)}</span>
//                                                 <ActionBox
//                                                 color={absence.LeaveType?.[0]?.color ?? "black"}
//                                                 onEdit={() => {
//                                                   setOpenData({ place: palceIndex, userIndex: index, dayIndex: entry.date, scheduleIndex });
//                                                   editAbsence(entry, item, scheduleIndex, absence);
//                                                 }}
//                                                 onDelete={() => {
//                                                   setOpenData({ place: palceIndex, userIndex: index, dayIndex: entry.date, scheduleIndex });
//                                                   editAbsence(entry, item, scheduleIndex, absence, true, { place: palceIndex, userIndex: index, dayIndex: entry.date, scheduleIndex });
//                                                 }}
//                                               ></ActionBox>
//                                               </Schedule>
//                                             );
//                                           })}
                                          
//                                           {!hasSchedule && isActive ? (
//                                             <BlankButton
//                                               onClick={() => {
//                                                 addNewSchedule(entry, { ...item, user: value.users._id });
//                                               }}
//                                             >
//                                               <GetIcon icon="add" />
//                                             </BlankButton>
//                                           ) : (
//                                             ""
//                                           )}
//                                         </SchedulesBox>
//                                         {/* <DropActionBox color={"black"} isUpcoming={isUpcoming && isActive} type={"schedule"} place={palceIndex} date={entry.date} userIndex={index} dayIndex={entry.date} user={item._id} placeId={value.placeId} addDate={new Date(entry.originalDate)}></DropActionBox> */}
//                                       </Td>
//                                     );
//                                   })}
//                                   {showWorked && (
//                                     <Td className={"total has"}>
//                                       <ColumnContainer className="justifyCenter">
//                                         <Progress achievedDisplay={`${convertMinutesToHHMM(totalHours)}`} totalDisplay={`/ ${convertMinutesToHHMM(plannedHours)}`} achieved={totalHours} total={plannedHours}></Progress>
//                                       </ColumnContainer>
//                                     </Td>
//                                   )}
//                                 </Tr>
//                               ) : null;
//                             })}
//                           </tbody>
//                           <div style={{ height: "20px" }}></div>
//                         </React.Fragment>
//                       )}
//                     </React.Fragment>
//                   );

//                   return result;
//                 })
//               ) : (
//                 <NoData>{t("notFound", { page: t(shortName) })}</NoData>
//               )}
//             </Table>
//           </ScrollLayout>
//         </ScrollContainerLayout>
//         {count > 0 && <Count>{t("showingData", { count ,records: count===1 ? t("Project") : t("Projects")})}</Count>}
//       </RowContainer>
//     </Container>
//   );
// };
// export default Layout(Duty);



import React, { useEffect, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import withLayout from "../../../common/layout";
import { Container } from "../../../common/layout/styels";
import { RowContainer } from "../../../../styles/containers/styles";
import moment from "moment";
import { AddButton, AvailabilitiesSchedule, ButtonContainer, CalendarTable, Schedule, SchedulesBox } from "./styles";
import { useDispatch, useSelector } from "react-redux";
import { GetIcon } from "../../../../../icons";
import { addPageObject } from "../../../../../store/actions/pages";
import {} from "../../attendance/schedules/styles";
import { timeFormat } from "../../../../functions/date";
import PopupView from "../../../../elements/popupview";
import { DisplayInformations } from "../../../../elements/list/popup";
import { postData, putData } from "../../../../../backend/api";
import AutoForm from "../../../../elements/form";
import { CenterBox } from "../../attendance/worklog/styles";
import { BlankButton } from "../../attendance/styels";
import { useNavigate } from "react-router-dom";

const Duty = ({setLoaderBox, setMessage,}) => {
  const me = useSelector((state) => state.login)
  const [currentApi] = useState(`shift/schedules`);
  const [t, i18n] = useTranslation();
  const [currentDate, setCurrentDate] = useState(moment().startOf("month"));
  const [calendar, setCalendar] = useState([]);
  const dispatch = useDispatch();
      const navigate = useNavigate();
  const themeColors = useSelector((state) => state.themeColors);
  useEffect(() => {
    document.title = `${t("calendar")} - PersoBase`;
  }, [t]);
  const selectedLanguage = i18n.language || "de";
  const daysInMonth = currentDate.daysInMonth();
  const firstDayOfMonth = currentDate.startOf("month").day();
  const [loadedData, setLoadedData] = useState([]);
  const [initialized] = useState(true);
  const [addAtrributes, setAddAttributes] = useState([]);
  const [condition] = useState({ item: "reccuring", if: true, then: "enabled", else: "disabled" });
  const [shiftCondition] = useState({ item: "shift", if: "", else: "enabled", then: "disabled" });
  const [isOpenSchedule, setIsOpenSchedule] = useState(false);
  const [isAddAvailability, setIsAddAvailability] = useState(false);
  const [openSchedule, setOpenSchedule] = useState({});
  const [openScheduleType, setOpenScheduleType] = useState("");
  const [saveApiUrl, setSaveApiUrl] = useState("");
  const [modifySchedule, setModifySchedule] = useState(false);
  const [isAddNewSchedule, setIsAddNewSchedule] = useState(false);
  const [title, setTitle] = useState("");
  const [userId, setUserId] = useState("nil");
  //Loading Data
  const users = useSelector((state) =>
    state.pages[`${currentApi}`]
      ? state.pages[`${currentApi}`]
      : {
          data: null,
          isLoading: true,
          error: null,
        }
  );
  useEffect(() => {
    if (initialized) {
      dispatch(addPageObject(currentApi, 0, 0,{viewMode: "month",
          show: "1",
          currentDate: new Date().toISOString(),
          startOfMonth: moment(new Date()).startOf("month").toISOString(),
          endOfMonth: moment(new Date()).endOf("month").toISOString(),
          startOfWeek: moment(new Date()).startOf("week").toISOString(),
          endOfWeek: moment(new Date()).endOf("week").toISOString(),}));
    }
  }, [initialized, currentApi, dispatch]);
  // const [draggedDates, setDraggedDates] = useState([]);
  useEffect(() => {
    setLoadedData(users);
  }, [users]);
  const daysOrder =
  selectedLanguage === "de"
    ? ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
    : ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

// Memoize the generateCalendar function with useCallback
const generateCalendar = useCallback(() => {
  const calendarTemp = [];
  let day = 1;

  // Adjust blankDays to start from Monday
  let blankDays = (firstDayOfMonth === 0 ? 6 : firstDayOfMonth - 1); // Adjust first day (0=Sun becomes 6, others shift back by 1)
  let week = [];

  while (day <= daysInMonth) {
    if (blankDays > 0) {
      week.push(null); // Add blank days
      blankDays--;
    } else {
      week.push(currentDate.clone().date(day)); // Add actual days
      day++;
    }

    if (week.length === 7 || day > daysInMonth) {
      calendarTemp.push(week); // Push completed week
      week = [];
    }
  }

  // Fill the last week with nulls to complete it if necessary
  const lastWeekDays = 7 - calendarTemp[calendarTemp.length - 1].length;
  if (lastWeekDays > 0) {
    for (let i = 0; i < lastWeekDays; i++) {
      calendarTemp[calendarTemp.length - 1].push(null);
    }
  }

  setCalendar(calendarTemp);
}, [currentDate, daysInMonth, firstDayOfMonth]);


  useEffect(() => {
    generateCalendar();
  }, [generateCalendar]);

  const handlePrevMonth = () => {
    const prevMonth = currentDate.clone().subtract(1, "month");
    setCurrentDate(prevMonth);
    dispatch(addPageObject(currentApi, 0, 0, { viewMode: "month",
        show: "1",
        currentDate: new Date(prevMonth).toISOString(),
        startOfMonth: moment(new Date(prevMonth)).startOf("month").toISOString(),
        endOfMonth: moment(new Date(prevMonth)).endOf("month").toISOString(),
        startOfWeek: moment(new Date(prevMonth)).startOf("week").toISOString(),
        endOfWeek: moment(new Date(prevMonth)).endOf("week").toISOString(), }));
  };

  const handleNextMonth = () => {
    const nextMonth = currentDate.clone().add(1, "month");
    setCurrentDate(nextMonth);
    dispatch(addPageObject(currentApi, 0, 0, { viewMode: "month",
      show: "1",
      currentDate: new Date(nextMonth).toISOString(),
      startOfMonth: moment(new Date(nextMonth)).startOf("month").toISOString(),
      endOfMonth: moment(new Date(nextMonth)).endOf("month").toISOString(),
      startOfWeek: moment(new Date(nextMonth)).startOf("week").toISOString(),
      endOfWeek: moment(new Date(nextMonth)).endOf("week").toISOString(),  }));
  };

  const renderCalendarHeader = () => (
    <tr>
      {daysOrder.map((day) => (
        <th className={`${day === "Sun" ? "sun":""}`} key={day}>{t(day)}</th>
      ))}
    </tr>
  );
  
  const handleSchedule = (schedule,day) => {
    let date = moment(day);
    setOpenSchedule(schedule)
    setOpenScheduleType("schedule");
    setAddAttributes([
      {
        type: "select",
        placeholder: "shift",
        name: "shiftTemplate",
        validation: "",
        updateCondition: [
          { item: "startTime", value: "shiftStart" },
          { item: "endTime", value: "shiftEnd" },
          { item: "break", value: "break" },
        ],
        tags: [
          { type: "time", item: "shiftStart", title: "shiftStart", collection: "" },
          { type: "time", item: "shiftEnd", title: "shiftEnd", collection: "" },
        ],
        default: "",
        label: "shift",
        showItem: "title",
        required: true,
        view: true,
        add: false,
        update: false,
        apiType: "API",
        selectApi: "shift/select",
        customClass: "half",
      },
      // {
      //   type: "select",
      //   placeholder: "place",
      //   name: "place",
      //   validation: "",
      //   condition: shiftCondition,
      //   default: "",
      //   label: "place",
      //   showItem: "title",
      //   required: true,
      //   view: true,
      //   add: false,
      //   update: false,
      //   apiType: "API",
      //   selectApi: "place/select",
      //   customClass: "half",
      // },
      {
        type: "date",
        placeholder: "scheduleDate",
        condition: shiftCondition,
        name: "startTime",
        validation: "",
        maxDate: date.clone().add(3, "months"),
        default: date.clone().startOf("day"),
        label: "scheduleDate",
        required: true,
        view: true,
        add: false,
        update: false,
      },
      {
        type: "time",
        placeholder: "startTime",
        condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
        name: "startTime",
        validation: "",
        default: schedule.startTime,
        label: "startTime",
        required: true,
        interval: 15,
        view: true,
        add: true,
        update: true,
      },
      {
        type: "time",
        placeholder: "endTime",
        name: "endTime",
        condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
        validation: "",
        default: schedule.endTime,
        label: "endTime",
        required: true,
        interval: 15,
        view: true,
        add: true,
        update: true,
      },
      // {
      //   type: "number",
      //   placeholder: "startBuffer",
      //   condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
      //   name: "startBuffer",
      //   validation: "",
      //   default: schedule.startBuffer,
      //   showItem: "value",
      //   label: "startBuffer",
      //   required: true,
      //   view: true,
      //   add: true,
      //   update: true,
      //   customClass: "half",
      //   filter: false,
      //   apiType: "JSON",
      //   selectApi: [
      //     { value: "10 minutes", id: 10 },
      //     { value: "15 minutes", id: 15 },
      //     { value: "20 minutes", id: 20 },
      //     { value: "25 minutes", id: 25 },
      //     { value: "30 minutes", id: 30 },
      //     { value: "45 minutes", id: 45 },
      //     { value: "60 minutes", id: 60 },
      //   ],
      // },
      // {
      //   type: "number",
      //   placeholder: "endBuffer",
      //   condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
      //   name: "endBuffer",
      //   validation: "",
      //   default: schedule.endBuffer,
      //   showItem: "value",
      //   label: "endBuffer",
      //   required: true,
      //   view: true,
      //   add: true,
      //   update: true,
      //   customClass: "half",
      //   filter: false,
      //   apiType: "JSON",
      //   selectApi: [
      //     { value: "10 minutes", id: 10 },
      //     { value: "15 minutes", id: 15 },
      //     { value: "20 minutes", id: 20 },
      //     { value: "25 minutes", id: 25 },
      //     { value: "30 minutes", id: 30 },
      //     { value: "45 minutes", id: 45 },
      //     { value: "60 minutes", id: 60 },
      //   ],
      // },
      // {
      //   type: "number",
      //   condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
      //   placeholder: "break",
      //   name: "break",
      //   validation: "",
      //   default: schedule.break,
      //   label: "break",
      //   required: true,
      //   minimum: 0,
      //   maximum: 60,
      //   view: true,
      //   add: true,
      //   update: true,
      // },
      
    ]);
    setIsOpenSchedule(true);
  }
  const applyOpenService = (schedule,day) => {
    let date = moment(day);
    setOpenSchedule(schedule)
    setOpenScheduleType("openServices");
    setAddAttributes([
      {
        type: "select",
        placeholder: "shift",
        name: "shiftDetails",
        validation: "",
        updateCondition: [
          { item: "startTime", value: "shiftStart" },
          { item: "endTime", value: "shiftEnd" },
          { item: "break", value: "break" },
        ],
        tags: [
          { type: "time", item: "shiftStart", title: "shiftStart", collection: "" },
          { type: "time", item: "shiftEnd", title: "shiftEnd", collection: "" },
        ],
        default: "",
        label: "shift",
        showItem: "shortForm",
        required: true,
        view: true,
        add: false,
        update: false,
        apiType: "API",
        selectApi: "shift/select",
        customClass: "half",
      },
      {
        type: "select",
        placeholder: "place",
        name: "place",
        validation: "",
        condition: shiftCondition,
        default: "",
        label: "place",
        showItem: "title",
        required: true,
        view: true,
        add: false,
        update: false,
        apiType: "API",
        selectApi: "place/select",
        customClass: "half",
      },
      {
        type: "date",
        placeholder: "scheduleDate",
        condition: shiftCondition,
        name: "startTime",
        validation: "",
        maxDate: date.clone().add(3, "months"),
        default: date.clone().startOf("day"),
        label: "scheduleDate",
        required: true,
        view: true,
        add: false,
        update: false,
      },
      {
        type: "time",
        placeholder: "startTime",
        condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
        name: "startTime",
        validation: "",
        default: schedule.startTime,
        label: "startTime",
        required: true,
        interval: 15,
        view: true,
        add: false,
        update: false,
      },
      {
        type: "time",
        placeholder: "endTime",
        name: "endTime",
        condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
        validation: "",
        default: schedule.endTime,
        label: "endTime",
        required: true,
        interval: 15,
        view: true,
        add: false,
        update: false,
      },
      {
        type: "number",
        placeholder: "startBuffer",
        condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
        name: "startBuffer",
        validation: "",
        default: schedule.startBuffer,
        showItem: "value",
        label: "startBuffer",
        required: true,
        view: true,
        add: false,
        update: false,
        customClass: "half",
        filter: false,
        apiType: "JSON",
        selectApi: [
          { value: "10 minutes", id: 10 },
          { value: "15 minutes", id: 15 },
          { value: "20 minutes", id: 20 },
          { value: "25 minutes", id: 25 },
          { value: "30 minutes", id: 30 },
          { value: "45 minutes", id: 45 },
          { value: "60 minutes", id: 60 },
        ],
      },
      {
        type: "number",
        placeholder: "endBuffer",
        condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
        name: "endBuffer",
        validation: "",
        default: schedule.endBuffer,
        showItem: "value",
        label: "endBuffer",
        required: true,
        view: true,
        add: false,
        update: false,
        customClass: "half",
        filter: false,
        apiType: "JSON",
        selectApi: [
          { value: "10 minutes", id: 10 },
          { value: "15 minutes", id: 15 },
          { value: "20 minutes", id: 20 },
          { value: "25 minutes", id: 25 },
          { value: "30 minutes", id: 30 },
          { value: "45 minutes", id: 45 },
          { value: "60 minutes", id: 60 },
        ],
      },
      {
        type: "number",
        condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
        placeholder: "break",
        name: "break",
        validation: "",
        default: schedule.break,
        label: "break",
        required: true,
        minimum: 0,
        maximum: 60,
        view: true,
        add: false,
        update: false,
      },
      {
        type: "number",
        placeholder: "Required Employee",
        name: "serviceCount",
        condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
        validation: "",
        default: "",
        showItem: "value",
        label: "Required Employee",
        required: true,
        view: true,
        add: false,
        update: false,
      },
      {
        type: "textarea",
        placeholder: "note",
        name: "title",
        validation: "",
        condition: shiftCondition,
        default: "",
        label: "note",
        required: false,
        view: true,
        add: false,
        update: false,
      },
      {
        type: "text",
        placeholder: "status",
        name: "userApplicationStatus",
        validation: "",
        label: "status",
        showItem: "status",
        view: true,
        add: false,
        update: false,
      },
      // {
      //   type: "info",
      //   condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
      //   name: "userApplicationStatus",
      //   validation: "",
      //   content: "Check below to delete this schedule",
      //   label: "status",
      //   showItem: "status",
      //   view: true,
      //   add: false,
      //   update: false,
      // },
      // {
      //   type: "info",
      //   condition: { item: "isDeleted", if: true, then: "enabled", else: "disabled" },
      //   name: "deleteSchedule",
      //   validation: "",
      //   content: "deleteWarning",
      //   label: "deleteSchedule",
      //   view: true,
      //   add: false,
      //   update: false,
      // },
      // {
      //   type: "checkbox",
      //   placeholder: "delete",
      //   name: "isDeleted",
      //   validation: "",
      //   default: false,
      //   label: "delete",
      //   required: true,
      //   minimum: 0,
      //   maximum: 60,
      //   view: true,
      //   add: false,
      //   update: false,
      // },
      // {
      //   type: "info",
      //   condition: { item: "deleteAll", if: true, then: "enabled", else: "disabled" },
      //   name: "deleteSchedule",
      //   validation: "",
      //   content: "deleteAllWarning",
      //   label: "deleteSchedule",
      //   view: true,
      //   add: false,
      //   update: false,
      // },
      // {
      //   type: "checkbox",
      //   placeholder: "deleteAll",
      //   name: "deleteAll",
      //   validation: "",
      //   condition: { item: "isDeleted", if: true, then: "enabled", else: "disabled" },
      //   default: false,
      //   label: "deleteAll",
      //   required: true,
      //   minimum: 0,
      //   maximum: 60,
      //   view: true,
      //   add: false,
      //   update: false,
      // },
    ]);
    setIsOpenSchedule(true);
  }

  const addNewAvailabilty = (day) => {
    let date = moment(day??new Date());
    setSaveApiUrl("availability")
    setAddAttributes([
      {
        type: "date",
        placeholder: "scheduleDate",
        name: "startDate",
        validation: "",
        maxDate: date.clone().add(3, "months"),
        default: date.clone().startOf("day").add(7, "hours"),
        label: "scheduleDate",
        required: true,
        view: true,
        add: true,
        update: true,
      },
      {
        type: "select",
        placeholder: "availability",
        name: "availableType",
        validation: "",
        default: "",
        showItem: "value",
        label: "availability",
        required: true,
        view: true,
        add: true,
        update: true,
        customClass: "half",
        filter: false,
        apiType: "JSON",
        selectApi: [
          { value: "full-day", id: "full-day" },
          { value: "available-from", id: "available-from" },
          { value: "not-full-day", id: "not-full-day" },
          // { value: "not-available-from", id: "not-available-from" }
        ],
      },
      {
        type: "time",
        placeholder: "startTime",
        condition: { item: "availableType", if: "available-from", then: "enabled", else: "disabled" },
        name: "startTime",
        validation: "",
        default: "",
        label: "startTime",
        required: true,
        interval: 15,
        view: true,
        add: true,
        update: true,
      },
      {
        type: "time",
        placeholder: "endTime",
        condition: { item: "availableType", if: "available-from", then: "enabled", else: "disabled" },
        name: "endTime",
        validation: "",
        default: "",
        label: "endTime",
        required: true,
        interval: 15,
        view: true,
        add: true,
        update: true,
      },
      {
        type: "textarea",
        placeholder: "reason",
        name: "reason",
        validation: "",
        condition: shiftCondition,
        default: "",
        label: "reason",
        required: false,
        view: true,
        add: true,
        update: true,
      },
      {
        type: "info",
        placeholder: "days",
        name: "days",
        validation: "",
        default: false,
        label: "days",
        required: true,
        minimum: 0,
        maximum: 60,
        view: true,
        add: true,
        update: true,
      },

      {
        type: "checkbox",
        placeholder: "reccuring",
        condition: shiftCondition,
        name: "reccuring",
        validation: "",
        default: false,
        label: "reccuring",
        required: true,
        minimum: 0,
        maximum: 60,
        view: true,
        add: true,
        update: true,
      },

      {
        type: "info",
        placeholder: "days",
        name: "days",
        content: "selectDays",
        validation: "",
        condition: condition,
        default: false,
        label: "days",
        required: true,
        minimum: 0,
        maximum: 60,
        view: true,
        add: true,
        update: true,
      },
      {
        type: "multiSelect",
        placeholder: "eligibleDays",
        name: "eligibleDays",
        listView: true,
        validation: "",
        default: "",
        label: "eligibleDays",
        required: true,
        view: true,
        condition: condition,
        customClass: "half",
        add: true,
        update: true,
        apiType: "JSON",
        selectApi: [
          { value: t("Monday"), id: "monday" },
          { value: t("Tuesday"), id: "tuesday" },
          { value: t("Wednesday"), id: "wednesday" },
          { value: t("Thursday"), id: "thursday" },
          { value: t("Friday"), id: "friday" },
          { value: t("Saturday"), id: "saturday" },
          { value: t("Sunday"), id: "sunday" },
        ],
      },
      {
        type: "date",
        placeholder: "scheduleEnd",
        name: "endDate",
        validation: "",
        customClass: "half",
        condition: condition,
        greater: "startDate",
        minDate: date.clone().add(1, "days"),
        maxDate: date.clone().add(3, "months"),
        default: date.clone().startOf("day").add(15, "hours"),
        label: "scheduleEnd",
        required: true,
        view: true,
        add: true,
        update: true,
      },
      
    ]);
    setIsAddAvailability(true);
  }
  const updateAvailabilty = (day,schedule) => {
    let date = moment(day??new Date());
    setSaveApiUrl(`availability/${schedule._id}`)
    setOpenSchedule(schedule)
    setAddAttributes([
      {
        type: "date",
        placeholder: "scheduleDate",
        name: "startDate",
        validation: "",
        maxDate: date.clone().add(3, "months"),
        default: date.clone().startOf("day").add(7, "hours"),
        label: "scheduleDate",
        required: true,
        view: true,
        add: true,
        update: true,
      },
      {
        type: "select",
        placeholder: "availability",
        name: "availableType",
        validation: "",
        default: schedule.availableType,
        label: "availability",
        showItem:"value",
        required: true,
        view: true,
        add: true,
        update: true,
        customClass: "half",
        filter: false,
        apiType: "JSON",
        selectApi: [
          { value: "full-day", id: "full-day" },
          { value: "available-from", id: "available-from" },
          { value: "not-full-day", id: "not-full-day" },
          // { value: "not-available-from", id: "not-available-from" }
        ],
      },
      {
        type: "time",
        placeholder: "startTime",
        condition: { item: "availableType", if: "available-from", then: "enabled", else: "disabled" },
        name: "startTime",
        validation: "",
        default: schedule.startTime,
        label: "startTime",
        required: true,
        interval: 15,
        view: true,
        add: true,
        update: true,
      },
      {
        type: "time",
        placeholder: "endTime",
        condition: { item: "availableType", if: "available-from", then: "enabled", else: "disabled" },
        name: "endTime",
        validation: "",
        default: schedule.endTime,
        label: "endTime",
        required: true,
        interval: 15,
        view: true,
        add: true,
        update: true,
      },
      {
        type: "textarea",
        placeholder: "reason",
        name: "reason",
        validation: schedule.reason,
        condition: shiftCondition,
        default: "",
        label: "reason",
        required: false,
        view: true,
        add: true,
        update: true,
      },
      // {
      //   type: "info",
      //   placeholder: "days",
      //   name: "days",
      //   validation: "",
      //   default: false,
      //   label: "days",
      //   required: true,
      //   minimum: 0,
      //   maximum: 60,
      //   view: true,
      //   add: true,
      //   update: true,
      // },

      // {
      //   type: "checkbox",
      //   placeholder: "reccuring",
      //   condition: shiftCondition,
      //   name: "reccuring",
      //   validation: "",
      //   default: false,
      //   label: "reccuring",
      //   required: true,
      //   minimum: 0,
      //   maximum: 60,
      //   view: true,
      //   add: true,
      //   update: true,
      // },

      // {
      //   type: "info",
      //   placeholder: "days",
      //   name: "days",
      //   content: "selectDays",
      //   validation: "",
      //   condition: condition,
      //   default: false,
      //   label: "days",
      //   required: true,
      //   minimum: 0,
      //   maximum: 60,
      //   view: true,
      //   add: true,
      //   update: true,
      // },
      // {
      //   type: "multiSelect",
      //   placeholder: "eligibleDays",
      //   name: "eligibleDays",
      //   listView: true,
      //   validation: "",
      //   default: "",
      //   label: "eligibleDays",
      //   required: true,
      //   view: true,
      //   condition: condition,
      //   customClass: "half",
      //   add: true,
      //   update: true,
      //   apiType: "JSON",
      //   selectApi: [
      //     { value: t("Monday"), id: "monday" },
      //     { value: t("Tuesday"), id: "tuesday" },
      //     { value: t("Wednesday"), id: "wednesday" },
      //     { value: t("Thursday"), id: "thursday" },
      //     { value: t("Friday"), id: "friday" },
      //     { value: t("Saturday"), id: "saturday" },
      //     { value: t("Sunday"), id: "sunday" },
      //   ],
      // },
      // {
      //   type: "date",
      //   placeholder: "scheduleEnd",
      //   name: "endDate",
      //   validation: "",
      //   customClass: "half",
      //   condition: condition,
      //   greater: "startDate",
      //   minDate: date.clone().add(1, "days"),
      //   maxDate: date.clone().add(3, "months"),
      //   default: date.clone().startOf("day").add(15, "hours"),
      //   label: "scheduleEnd",
      //   required: true,
      //   view: true,
      //   add: true,
      //   update: true,
      // },
      
    ]);
    setModifySchedule(true);
  }

  const addNewAbsence = (entry, item) => {
      let date = moment(entry.originalDate ?? new Date());
      setTitle("absence");
      setSaveApiUrl("user/addAbsence");
      setAddAttributes([
        {
          type: "date",
          placeholder: "scheduleDate",
          name: "startDate",
          customClass: "half",
          validation: "",
          minDate: date.clone(),
          maxDate: date.clone().add(3, "months"),
          default: date.clone().startOf("day").add(7, "hours"),
          label: "scheduleDate",
          required: true,
          view: true,
          add: true,
          update: true,
        },
        {
          type: "date",
          placeholder: "scheduleEnd",
          name: "endDate",
          validation: "",
          customClass: "half",
          greater: "startDate",
          minDate: date.clone().add(1, "days"),
          maxDate: date.clone().add(3, "months"),
          default: date.clone().startOf("day").add(15, "hours"),
          label: "scheduleEnd",
          required: true,
          view: true,
          add: true,
          update: true,
        },
        {
          type: "multiSelect",
          placeholder: "employee",
          name: "user",
          condition: shiftCondition,
          tags: [
            { item: "title", title: "place", collection: "place" },
            { item: "title", title: "shift", collection: "shiftTemplate" },
          ],
          validation: "",
          default: "",
          label: "employee",
          showItem: "employee",
          required: true,
          view: true,
          add: true,
          update: true,
          apiType: "API",
          selectApi: "user/select",
          customClass: "half",
        },
        {
          type: "select",
          placeholder: "leaveType",
          name: "leaveType",
          validation: "",
          default: "",
          label: "leaveType",
          showItem: "locale",
          required: true,
          view: true,
          add: true,
          update: true,
          apiType: "API",
          selectApi: "leave-type/select",
          customClass: "half",
        },
        {
          type: "textarea",
          placeholder: "notes",
          name: "note",
          validation: "",
          default: "",
          label: "notes",
          required: false,
          view: true,
          add: true,
          update: true,
        },
      ]);
  
      setIsAddNewSchedule(true);
    };

  const actionFunction = ()=>{
    setLoaderBox(true);
    postData({id:openSchedule._id}, `user/appliedToOpenService`, dispatch, navigate)
      .then((response) => {
        if (response.status === 200) {
          setMessage({ type: 1, content: t(response.data.message), proceed: "Okay", code: 200 });
          let loadedDataTemp = {...loadedData};
          let index = loadedDataTemp?.data?.openService?.findIndex((service) => service._id === openSchedule._id)
          if(index>=0)
            loadedDataTemp.data.openService[index] = response.data?.data;
          setLoadedData(loadedDataTemp);
          setIsOpenSchedule(false);
        } else if (response.status === 404) {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 404 });
        } else {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 500 });
        }
        setLoaderBox(false);
      })
      .catch((error) => {
        setMessage({ type: 1, content: error.message + "Something went wrong!", proceed: "Okay", code: 500 });
        setLoaderBox(false);
      });
  }

  const submitHandler = async (data) => {
    setLoaderBox(true);
    await postData(data, saveApiUrl, dispatch, navigate)
      .then((response) => {
        if (response.status === 200) {
          setMessage({ type: 1, content: t(response.data.message), proceed: "Okay", code: 200 });
          // refreshView(currentIndex);
          setIsAddNewSchedule(false);
        } else if (response.status === 404) {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 404 });
        } else {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 500 });
        }
        setLoaderBox(false);
      })
      .catch((error) => {
        alert(error);
        setLoaderBox(false);
      });
  
  };

  const updateHandler = async (data) => {
    setLoaderBox(true);

    await putData(data, saveApiUrl, dispatch, navigate)
      .then((response) => {
        if (response.status === 200) {
          setMessage({ type: 1, content: t(response.data.message), proceed: "Okay", code: 200 }); 
          // refreshView(currentIndex);
          setModifySchedule(false);
        } else if (response.status === 404) {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 404 });
        } else {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 500 });
        }
        setLoaderBox(false);
      })
      .catch((error) => {
        alert(error);
        setLoaderBox(false);
      });
  };


  return (
    <Container className="noshadow">
      <RowContainer className="custom">
        <AddButton theme={themeColors}>
          <button onClick={() => addNewAbsence({}, {})}>
          <GetIcon icon={"add"}></GetIcon>
          {t("absence")}
          </button>
        </AddButton>
        <ButtonContainer theme={themeColors}>
          <button onClick={handlePrevMonth}>
            <GetIcon icon={"previous"}></GetIcon>
            {t("Previous Month")}
          </button>
          <button onClick={handleNextMonth}>
            {t("Next Month")}
            <GetIcon icon={"next"}></GetIcon>
          </button>
        </ButtonContainer>
        <CalendarTable theme={themeColors}>
          <thead>
            <tr>
              <th colSpan="7">{`${t(`month-${currentDate.format("M")}`)} ${currentDate.format("YYYY")}`}</th>
            </tr>
            {renderCalendarHeader()}
          </thead>
          <tbody>
            {calendar.map((week, weekIndex) => (
              <tr key={weekIndex}>
                {week.map((day, dayIndex) => (
                  <td className={day ? "enable" : "disabled"} key={dayIndex} >
                    {day ? (
                      <>
                        <span className={`dayNumber ${day.clone().format("d") === "0" ? "sun":""}`}>{day.clone().format("D")}</span>
                        <SchedulesBox style={{paddingTop: window.innerWidth > 768 ? "" : "25px"}} key={dayIndex} className={loadedData.data?.availabilities?.length>0 ? "availability":""}
                          onClick={(e) => {
                            console.log(e.target.classList);
                            // Check if the click happened on the data area
                            if (!e.target.classList.contains("data-box")) {
                              addNewAvailabilty(day); 
                            }
                          }}
                          >

                          {(loadedData?.data?.userData?.length>0 && loadedData.data?.userData?.[0]?.users?.length>0) ? loadedData.data?.userData?.[0]?.users?.map((user, index) => {
                            return (
                              <>
                                {user?.availability?.[day.clone().format("YYYY-MM-DD")] && user?.availability?.[day.clone().format("YYYY-MM-DD")]?.items?.map((schedule, index) => {
                              return (
                                <AvailabilitiesSchedule
                                  key={schedule._id}
                                  value={schedule._id}
                                  style={{
                                    backgroundColor: (schedule.availableType==="not-full-day" || schedule.availableType==="not-available-from" ) ?"#FF0000":"#9ee0bb",
                                  }}
                                  className="data-box"
                                  >
                                  <div className="data-box">{user?.fullName}</div>
                                  {schedule.availableType==="available-from" ? window.innerWidth > 768 ? <span className="available-from data-box">
                                    {`${timeFormat(schedule.startTime)} - ${timeFormat(schedule.endTime)} ${window.innerWidth > 768 ? schedule?.reason:""}`}
                                  </span> : <>
                                    <div className="data-box">{`${timeFormat(schedule.startTime)}`}</div>
                                    <div className="data-box">{`${timeFormat(schedule.endTime)}`}</div>
                                  </>
                                  : <span className="available-from data-box">
                                  {t(`type-${schedule.availableType}`)}
                                </span>
                                  }
                                </AvailabilitiesSchedule>
                              );
                            })
                            }

                            {user?.absences?.[day.clone().format("YYYY-MM-DD")] && user?.absences?.[day.clone().format("YYYY-MM-DD")]?.items?.map((absense, index) => {
                              return (
                              <Schedule key={index} color={absense.approval==="Confirmed" ? "#27e37a" : absense.approval==="Pending" ? "orange" : "red"} className="data-box">
                                <span className="data-box">{user?.fullName}</span>
                                <span className="data-box">{absense.LeaveType?.[0]?.[selectedLanguage]}</span>
                                <span className="data-box">{window.innerWidth > 768 ? absense.note : (absense?.note?.length > 10 ? (absense.note.slice(0,10)+"...") : absense.note)}</span>
                              </Schedule>
                            )})
                            }
                          
                              </>
                            );
                          }) : null}

                          {loadedData.data?.holidays[day.clone().format("YYYY-MM-DD")] ? (
                            <Schedule key={0} color={"red"} className="data-box">
                              <span className="data-box">{t("holiday")}</span>
                              {window.innerWidth > 768 && <span className="data-box">{loadedData.data?.holidays[day.clone().format("YYYY-MM-DD")]}</span>}
                            </Schedule>
                          ): null}
                          
                        </SchedulesBox>
                      </>
                    ) : // Render nothing for days without data
                    null}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </CalendarTable>
      </RowContainer>
      {isAddNewSchedule && (
        <AutoForm
          userId={userId}
          useCaptcha={false}
          useCheckbox={false}
          description={""}
          setMessage={setMessage}
          key={"type.description"}
          formType={"post"}
          header={t("addNewTitle", { label: t(title) })}
          formInput={addAtrributes}
          submitHandler={submitHandler}
          button={t("submit")}
          isOpenHandler={(value) => {
            setIsAddNewSchedule(value);
          }}
          isOpen={true}
          plainForm={false}
        ></AutoForm>
      )}
      {/* {isOpenSchedule && (
        <PopupView
          popupData={
            <DisplayInformations
              udpateView={false}
              isEditingHandler={false}
              actions={null}
              setMessage={setMessage}
              setLoaderBox={setLoaderBox}
              formMode={"double"}
              formView={"normal"}
              attributes={addAtrributes}
              data={openSchedule}
              api={"api"}
              tabName={openScheduleType}
            />
          }
          closeModal={() => {
            setIsOpenSchedule(false);
          }}
          setMessage={setMessage}
          setLoaderBox={setLoaderBox}
          profileImage={null}
          itemTitle={openScheduleType}
          openData={{ data: openSchedule }}
          customClass={"normal"}
          actionButton={openScheduleType === "openServices" ? (openSchedule?.userApplicationStatus?.status === "confirmed" || openSchedule?.userApplicationStatus?.status === "rejected" ? false : true) : false}
          actionFunction={actionFunction}
        ></PopupView>
      )}
      {isAddAvailability && (
        <AutoForm
          userId={me?.data?.user?._id}
          useCaptcha={false}
          useCheckbox={false}
          description={""}
          setMessage={setMessage}
          key={"type.description"}
          formType={"post"}
          header={t("addNewTitle", { label: t("addAvailability") })}
          formInput={addAtrributes}
          submitHandler={submitHandler}
          button={t("submit")}
          isOpenHandler={(value) => {
            setIsAddAvailability(value);
          }}
          isOpen={true}
          plainForm={false}
        ></AutoForm>
      )}
      {modifySchedule && (
        <AutoForm
          userId={me?.data?.user?._id}
          useCaptcha={false}
          useCheckbox={false}
          description={""}
          formValues={openSchedule}
          setMessage={setMessage}
          key={"type.description"}
          formType={"put"}
          header={t("update", { label: t("updateAvailability") })}
          formInput={addAtrributes}
          submitHandler={updateHandler}
          button={t("submit")}
          isOpenHandler={(value) => {
            setModifySchedule(value);
          }}
          isOpen={true}
          plainForm={false}
        ></AutoForm>
      )} */}
    </Container>
  );
};

export default withLayout(Duty);

